// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.35.0
// source: common/trading.proto
/* eslint-disable */
import { BinaryReader, BinaryWriter } from '@bufbuild/protobuf/wire'

import {
  Exchange,
  exchangeFromJSON,
  exchangeToJSON,
  InstrumentKind,
  instrumentKindFromJSON,
  instrumentKindToJSON,
  Liquidation,
  liquidationFromJSON,
  liquidationToJSON,
  MarginScope,
  marginScopeFromJSON,
  marginScopeToJSON,
  OptionType,
  optionTypeFromJSON,
  optionTypeToJSON,
  TradeVenue,
  tradeVenueFromJSON,
  tradeVenueToJSON,
} from './types'

export const protobufPackage = 'common.trading'

/** Order side enum */
export enum OrderSide {
  ORDER_SIDE_UNSPECIFIED = 0,
  ORDER_SIDE_BUY = 1,
  ORDER_SIDE_SELL = 2,
  UNRECOGNIZED = -1,
}

export function orderSideFromJSON(object: any): OrderSide {
  switch (object) {
    case 0:
    case 'ORDER_SIDE_UNSPECIFIED':
      return OrderSide.ORDER_SIDE_UNSPECIFIED
    case 1:
    case 'ORDER_SIDE_BUY':
      return OrderSide.ORDER_SIDE_BUY
    case 2:
    case 'ORDER_SIDE_SELL':
      return OrderSide.ORDER_SIDE_SELL
    case -1:
    case 'UNRECOGNIZED':
    default:
      return OrderSide.UNRECOGNIZED
  }
}

export function orderSideToJSON(object: OrderSide): string {
  switch (object) {
    case OrderSide.ORDER_SIDE_UNSPECIFIED:
      return 'ORDER_SIDE_UNSPECIFIED'
    case OrderSide.ORDER_SIDE_BUY:
      return 'ORDER_SIDE_BUY'
    case OrderSide.ORDER_SIDE_SELL:
      return 'ORDER_SIDE_SELL'
    case OrderSide.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum Denomination {
  DENOMINATION_UNSPECIFIED = 0,
  DENOMINATION_BASE = 1,
  DENOMINATION_QUOTE = 2,
  UNRECOGNIZED = -1,
}

export function denominationFromJSON(object: any): Denomination {
  switch (object) {
    case 0:
    case 'DENOMINATION_UNSPECIFIED':
      return Denomination.DENOMINATION_UNSPECIFIED
    case 1:
    case 'DENOMINATION_BASE':
      return Denomination.DENOMINATION_BASE
    case 2:
    case 'DENOMINATION_QUOTE':
      return Denomination.DENOMINATION_QUOTE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return Denomination.UNRECOGNIZED
  }
}

export function denominationToJSON(object: Denomination): string {
  switch (object) {
    case Denomination.DENOMINATION_UNSPECIFIED:
      return 'DENOMINATION_UNSPECIFIED'
    case Denomination.DENOMINATION_BASE:
      return 'DENOMINATION_BASE'
    case Denomination.DENOMINATION_QUOTE:
      return 'DENOMINATION_QUOTE'
    case Denomination.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/** Order type enum */
export enum OrderType {
  ORDER_TYPE_UNSPECIFIED = 0,
  ORDER_TYPE_MARKET = 1,
  ORDER_TYPE_LIMIT = 2,
  /** ORDER_TYPE_LIQUIDATION - special order type to indicate liquidations */
  ORDER_TYPE_LIQUIDATION = 3,
  UNRECOGNIZED = -1,
}

export function orderTypeFromJSON(object: any): OrderType {
  switch (object) {
    case 0:
    case 'ORDER_TYPE_UNSPECIFIED':
      return OrderType.ORDER_TYPE_UNSPECIFIED
    case 1:
    case 'ORDER_TYPE_MARKET':
      return OrderType.ORDER_TYPE_MARKET
    case 2:
    case 'ORDER_TYPE_LIMIT':
      return OrderType.ORDER_TYPE_LIMIT
    case 3:
    case 'ORDER_TYPE_LIQUIDATION':
      return OrderType.ORDER_TYPE_LIQUIDATION
    case -1:
    case 'UNRECOGNIZED':
    default:
      return OrderType.UNRECOGNIZED
  }
}

export function orderTypeToJSON(object: OrderType): string {
  switch (object) {
    case OrderType.ORDER_TYPE_UNSPECIFIED:
      return 'ORDER_TYPE_UNSPECIFIED'
    case OrderType.ORDER_TYPE_MARKET:
      return 'ORDER_TYPE_MARKET'
    case OrderType.ORDER_TYPE_LIMIT:
      return 'ORDER_TYPE_LIMIT'
    case OrderType.ORDER_TYPE_LIQUIDATION:
      return 'ORDER_TYPE_LIQUIDATION'
    case OrderType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/** Order status enum */
export enum OrderStatus {
  ORDER_STATUS_UNSPECIFIED = 0,
  ORDER_STATUS_PENDING = 1,
  ORDER_STATUS_OPEN = 2,
  ORDER_STATUS_PARTIALLY_FILLED = 3,
  ORDER_STATUS_FILLED = 4,
  ORDER_STATUS_CANCELLED = 5,
  ORDER_STATUS_REJECTED = 6,
  UNRECOGNIZED = -1,
}

export function orderStatusFromJSON(object: any): OrderStatus {
  switch (object) {
    case 0:
    case 'ORDER_STATUS_UNSPECIFIED':
      return OrderStatus.ORDER_STATUS_UNSPECIFIED
    case 1:
    case 'ORDER_STATUS_PENDING':
      return OrderStatus.ORDER_STATUS_PENDING
    case 2:
    case 'ORDER_STATUS_OPEN':
      return OrderStatus.ORDER_STATUS_OPEN
    case 3:
    case 'ORDER_STATUS_PARTIALLY_FILLED':
      return OrderStatus.ORDER_STATUS_PARTIALLY_FILLED
    case 4:
    case 'ORDER_STATUS_FILLED':
      return OrderStatus.ORDER_STATUS_FILLED
    case 5:
    case 'ORDER_STATUS_CANCELLED':
      return OrderStatus.ORDER_STATUS_CANCELLED
    case 6:
    case 'ORDER_STATUS_REJECTED':
      return OrderStatus.ORDER_STATUS_REJECTED
    case -1:
    case 'UNRECOGNIZED':
    default:
      return OrderStatus.UNRECOGNIZED
  }
}

export function orderStatusToJSON(object: OrderStatus): string {
  switch (object) {
    case OrderStatus.ORDER_STATUS_UNSPECIFIED:
      return 'ORDER_STATUS_UNSPECIFIED'
    case OrderStatus.ORDER_STATUS_PENDING:
      return 'ORDER_STATUS_PENDING'
    case OrderStatus.ORDER_STATUS_OPEN:
      return 'ORDER_STATUS_OPEN'
    case OrderStatus.ORDER_STATUS_PARTIALLY_FILLED:
      return 'ORDER_STATUS_PARTIALLY_FILLED'
    case OrderStatus.ORDER_STATUS_FILLED:
      return 'ORDER_STATUS_FILLED'
    case OrderStatus.ORDER_STATUS_CANCELLED:
      return 'ORDER_STATUS_CANCELLED'
    case OrderStatus.ORDER_STATUS_REJECTED:
      return 'ORDER_STATUS_REJECTED'
    case OrderStatus.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum PositionSide {
  POSITION_SIDE_UNSPECIFIED = 0,
  POSITION_SIDE_LONG = 1,
  POSITION_SIDE_SHORT = 2,
  UNRECOGNIZED = -1,
}

export function positionSideFromJSON(object: any): PositionSide {
  switch (object) {
    case 0:
    case 'POSITION_SIDE_UNSPECIFIED':
      return PositionSide.POSITION_SIDE_UNSPECIFIED
    case 1:
    case 'POSITION_SIDE_LONG':
      return PositionSide.POSITION_SIDE_LONG
    case 2:
    case 'POSITION_SIDE_SHORT':
      return PositionSide.POSITION_SIDE_SHORT
    case -1:
    case 'UNRECOGNIZED':
    default:
      return PositionSide.UNRECOGNIZED
  }
}

export function positionSideToJSON(object: PositionSide): string {
  switch (object) {
    case PositionSide.POSITION_SIDE_UNSPECIFIED:
      return 'POSITION_SIDE_UNSPECIFIED'
    case PositionSide.POSITION_SIDE_LONG:
      return 'POSITION_SIDE_LONG'
    case PositionSide.POSITION_SIDE_SHORT:
      return 'POSITION_SIDE_SHORT'
    case PositionSide.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum TimeInForce {
  TIF_UNSPECIFIED = 0,
  /** TIF_GTC - Good Till Canceled (default) */
  TIF_GTC = 1,
  /** TIF_IOC - Immediate or Cancel */
  TIF_IOC = 2,
  /** TIF_FOK - Fill or Kill */
  TIF_FOK = 3,
  /** TIF_GTD - Good Till Day */
  TIF_GTD = 4,
  UNRECOGNIZED = -1,
}

export function timeInForceFromJSON(object: any): TimeInForce {
  switch (object) {
    case 0:
    case 'TIF_UNSPECIFIED':
      return TimeInForce.TIF_UNSPECIFIED
    case 1:
    case 'TIF_GTC':
      return TimeInForce.TIF_GTC
    case 2:
    case 'TIF_IOC':
      return TimeInForce.TIF_IOC
    case 3:
    case 'TIF_FOK':
      return TimeInForce.TIF_FOK
    case 4:
    case 'TIF_GTD':
      return TimeInForce.TIF_GTD
    case -1:
    case 'UNRECOGNIZED':
    default:
      return TimeInForce.UNRECOGNIZED
  }
}

export function timeInForceToJSON(object: TimeInForce): string {
  switch (object) {
    case TimeInForce.TIF_UNSPECIFIED:
      return 'TIF_UNSPECIFIED'
    case TimeInForce.TIF_GTC:
      return 'TIF_GTC'
    case TimeInForce.TIF_IOC:
      return 'TIF_IOC'
    case TimeInForce.TIF_FOK:
      return 'TIF_FOK'
    case TimeInForce.TIF_GTD:
      return 'TIF_GTD'
    case TimeInForce.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Open category resolved by the compiler against the account's settlement
 * preferences. Add variants as new prompts demand them — keep it narrow.
 */
export enum AssetCategory {
  ASSET_CATEGORY_UNSPECIFIED = 0,
  /**
   * ASSET_CATEGORY_STABLE_COIN - "Cash" / stablecoin balance. Compiler resolves to the account's
   * preferred stablecoin (USDC, USDT, ...).
   */
  ASSET_CATEGORY_STABLE_COIN = 1,
  UNRECOGNIZED = -1,
}

export function assetCategoryFromJSON(object: any): AssetCategory {
  switch (object) {
    case 0:
    case 'ASSET_CATEGORY_UNSPECIFIED':
      return AssetCategory.ASSET_CATEGORY_UNSPECIFIED
    case 1:
    case 'ASSET_CATEGORY_STABLE_COIN':
      return AssetCategory.ASSET_CATEGORY_STABLE_COIN
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AssetCategory.UNRECOGNIZED
  }
}

export function assetCategoryToJSON(object: AssetCategory): string {
  switch (object) {
    case AssetCategory.ASSET_CATEGORY_UNSPECIFIED:
      return 'ASSET_CATEGORY_UNSPECIFIED'
    case AssetCategory.ASSET_CATEGORY_STABLE_COIN:
      return 'ASSET_CATEGORY_STABLE_COIN'
    case AssetCategory.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum LiquidityType {
  LIQUIDITY_TYPE_UNSPECIFIED = 0,
  LIQUIDITY_TYPE_MAKER = 1,
  LIQUIDITY_TYPE_TAKER = 2,
  LIQUIDITY_TYPE_MIXED = 3,
  UNRECOGNIZED = -1,
}

export function liquidityTypeFromJSON(object: any): LiquidityType {
  switch (object) {
    case 0:
    case 'LIQUIDITY_TYPE_UNSPECIFIED':
      return LiquidityType.LIQUIDITY_TYPE_UNSPECIFIED
    case 1:
    case 'LIQUIDITY_TYPE_MAKER':
      return LiquidityType.LIQUIDITY_TYPE_MAKER
    case 2:
    case 'LIQUIDITY_TYPE_TAKER':
      return LiquidityType.LIQUIDITY_TYPE_TAKER
    case 3:
    case 'LIQUIDITY_TYPE_MIXED':
      return LiquidityType.LIQUIDITY_TYPE_MIXED
    case -1:
    case 'UNRECOGNIZED':
    default:
      return LiquidityType.UNRECOGNIZED
  }
}

export function liquidityTypeToJSON(object: LiquidityType): string {
  switch (object) {
    case LiquidityType.LIQUIDITY_TYPE_UNSPECIFIED:
      return 'LIQUIDITY_TYPE_UNSPECIFIED'
    case LiquidityType.LIQUIDITY_TYPE_MAKER:
      return 'LIQUIDITY_TYPE_MAKER'
    case LiquidityType.LIQUIDITY_TYPE_TAKER:
      return 'LIQUIDITY_TYPE_TAKER'
    case LiquidityType.LIQUIDITY_TYPE_MIXED:
      return 'LIQUIDITY_TYPE_MIXED'
    case LiquidityType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum TransferDirection {
  TRANSFER_DIRECTION_UNSPECIFIED = 0,
  TRANSFER_DIRECTION_DEPOSIT = 1,
  TRANSFER_DIRECTION_WITHDRAWAL = 2,
  UNRECOGNIZED = -1,
}

export function transferDirectionFromJSON(object: any): TransferDirection {
  switch (object) {
    case 0:
    case 'TRANSFER_DIRECTION_UNSPECIFIED':
      return TransferDirection.TRANSFER_DIRECTION_UNSPECIFIED
    case 1:
    case 'TRANSFER_DIRECTION_DEPOSIT':
      return TransferDirection.TRANSFER_DIRECTION_DEPOSIT
    case 2:
    case 'TRANSFER_DIRECTION_WITHDRAWAL':
      return TransferDirection.TRANSFER_DIRECTION_WITHDRAWAL
    case -1:
    case 'UNRECOGNIZED':
    default:
      return TransferDirection.UNRECOGNIZED
  }
}

export function transferDirectionToJSON(object: TransferDirection): string {
  switch (object) {
    case TransferDirection.TRANSFER_DIRECTION_UNSPECIFIED:
      return 'TRANSFER_DIRECTION_UNSPECIFIED'
    case TransferDirection.TRANSFER_DIRECTION_DEPOSIT:
      return 'TRANSFER_DIRECTION_DEPOSIT'
    case TransferDirection.TRANSFER_DIRECTION_WITHDRAWAL:
      return 'TRANSFER_DIRECTION_WITHDRAWAL'
    case TransferDirection.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/** How a curve behaves BETWEEN its points. */
export enum MarginCurveShape {
  /** MARGIN_CURVE_SHAPE_UNSPECIFIED - treated as CONTINUOUS */
  MARGIN_CURVE_SHAPE_UNSPECIFIED = 0,
  /** MARGIN_CURVE_SHAPE_CONTINUOUS - Samples of a smooth formula (Deribit SM). Interpolate between rungs. */
  MARGIN_CURVE_SHAPE_CONTINUOUS = 1,
  /**
   * MARGIN_CURVE_SHAPE_TIERED - A tier table (Bybit risk limits), not samples: each point's leverage
   * applies to EVERY size up to that point's `position_size`, then steps down.
   * Interpolating one would overstate leverage between tiers, which is the
   * unsafe direction.
   */
  MARGIN_CURVE_SHAPE_TIERED = 2,
  UNRECOGNIZED = -1,
}

export function marginCurveShapeFromJSON(object: any): MarginCurveShape {
  switch (object) {
    case 0:
    case 'MARGIN_CURVE_SHAPE_UNSPECIFIED':
      return MarginCurveShape.MARGIN_CURVE_SHAPE_UNSPECIFIED
    case 1:
    case 'MARGIN_CURVE_SHAPE_CONTINUOUS':
      return MarginCurveShape.MARGIN_CURVE_SHAPE_CONTINUOUS
    case 2:
    case 'MARGIN_CURVE_SHAPE_TIERED':
      return MarginCurveShape.MARGIN_CURVE_SHAPE_TIERED
    case -1:
    case 'UNRECOGNIZED':
    default:
      return MarginCurveShape.UNRECOGNIZED
  }
}

export function marginCurveShapeToJSON(object: MarginCurveShape): string {
  switch (object) {
    case MarginCurveShape.MARGIN_CURVE_SHAPE_UNSPECIFIED:
      return 'MARGIN_CURVE_SHAPE_UNSPECIFIED'
    case MarginCurveShape.MARGIN_CURVE_SHAPE_CONTINUOUS:
      return 'MARGIN_CURVE_SHAPE_CONTINUOUS'
    case MarginCurveShape.MARGIN_CURVE_SHAPE_TIERED:
      return 'MARGIN_CURVE_SHAPE_TIERED'
    case MarginCurveShape.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/** What `position_size` counts. */
export enum MarginCurveSizeUnit {
  /** MARGIN_CURVE_SIZE_UNIT_UNSPECIFIED - treated as BASE */
  MARGIN_CURVE_SIZE_UNIT_UNSPECIFIED = 0,
  MARGIN_CURVE_SIZE_UNIT_BASE = 1,
  /**
   * MARGIN_CURVE_SIZE_UNIT_QUOTE - Quote-currency position VALUE (Bybit linear risk limits are in USDT).
   * Consumers convert with the live price at evaluation time — converting at
   * publish time would bake in a stale price and move every tier boundary as
   * the market drifts.
   */
  MARGIN_CURVE_SIZE_UNIT_QUOTE = 2,
  UNRECOGNIZED = -1,
}

export function marginCurveSizeUnitFromJSON(object: any): MarginCurveSizeUnit {
  switch (object) {
    case 0:
    case 'MARGIN_CURVE_SIZE_UNIT_UNSPECIFIED':
      return MarginCurveSizeUnit.MARGIN_CURVE_SIZE_UNIT_UNSPECIFIED
    case 1:
    case 'MARGIN_CURVE_SIZE_UNIT_BASE':
      return MarginCurveSizeUnit.MARGIN_CURVE_SIZE_UNIT_BASE
    case 2:
    case 'MARGIN_CURVE_SIZE_UNIT_QUOTE':
      return MarginCurveSizeUnit.MARGIN_CURVE_SIZE_UNIT_QUOTE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return MarginCurveSizeUnit.UNRECOGNIZED
  }
}

export function marginCurveSizeUnitToJSON(object: MarginCurveSizeUnit): string {
  switch (object) {
    case MarginCurveSizeUnit.MARGIN_CURVE_SIZE_UNIT_UNSPECIFIED:
      return 'MARGIN_CURVE_SIZE_UNIT_UNSPECIFIED'
    case MarginCurveSizeUnit.MARGIN_CURVE_SIZE_UNIT_BASE:
      return 'MARGIN_CURVE_SIZE_UNIT_BASE'
    case MarginCurveSizeUnit.MARGIN_CURVE_SIZE_UNIT_QUOTE:
      return 'MARGIN_CURVE_SIZE_UNIT_QUOTE'
    case MarginCurveSizeUnit.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Shared asset identity. Either an explicit ticker (BTC, ETH, USDC, ...)
 * or a category the compiler resolves against the account (e.g. "cash" →
 * the account's preferred stablecoin). Most callsites only emit `asset`;
 * `category` is primarily for rebalance / allocate-budget targets where
 * the user said "cash" without committing to a specific stablecoin.
 */
export interface AssetRef {
  asset?: string | undefined
  category?: AssetCategory | undefined
}

/** Instrument Trade */
export interface InstrumentTrade {
  /** SYMBOL - e.g., "BTC-29MAR24-60000-C" */
  symbol: string
  /** VARCHAR - unique trade identifier */
  tradeId: string
  /** SYMBOL - "BUY" or "SELL" */
  side: OrderSide
  /** DOUBLE - price per unit */
  price: number
  /** DOUBLE - quantity traded */
  quantity: number
  /** DOUBLE - quantity in quote currency (price * quantity) */
  quantityQuote: number
  /** SYMBOL - underlying asset, e.g., "BTC" */
  underlying: string
  /** DOUBLE - implied volatility */
  iv?: number | undefined
  /** SYMBOL - "CALL" or "PUT" (if applicable) */
  optionType?: OptionType | undefined
  /** DECIMAL(19, 10) - stored as string for precision */
  strikePrice?: string | undefined
  /** TIMESTAMP - option expiration */
  expiry?: string | undefined
  /** VARCHAR - block trade identifier (if applicable) */
  blockTradeId?: string | undefined
  /** M T or MT - whether this is a liquidation */
  liquidation?: Liquidation | undefined
  /** SYMBOL - e.g., "deribit", "binance" */
  exchange: Exchange
  /** TIMESTAMP - Unix nanoseconds (primary time column). */
  timestampNs: string
  /**
   * Producers MUST emit native ns precision. Rename
   * from `timestamp` (ms) preserves wire tag but breaks
   * stale consumers at compile time — see
   * migrations/0004-trade-timestamp-ns.md.
   */
  indexPrice?: number | undefined
}

/**
 * Top-of-book + mark snapshot captured at the instant an order is placed / a
 * trade fills. Stamped from the live InstrumentCache; all fields optional
 * (a cache miss yields an empty snapshot, never a blocked order/fill).
 */
export interface BenchmarkSnapshot {
  bid?: string | undefined
  ask?: string | undefined
  mid?: string | undefined
  mark?: string | undefined
  underlying?: string | undefined
}

/**
 * Trade information.
 *
 * `exchange`, `trade_venue`, and `venue_symbol` are all required and always
 * populated. For full-stack venues (Deribit/Binance) the values are equal;
 * for cross-market routing (e.g. IBKR account against GLBX data) they differ.
 */
export interface Trade {
  id: string
  orderId: string
  accountId: string
  symbol: string
  /** underlying market — always populated */
  exchange: Exchange
  side: OrderSide
  /** Decimal as string */
  quantity: string
  /** Decimal as string */
  price: string
  /** Decimal as string */
  fee?: string | undefined
  feeCurrency?: string | undefined
  executedAt: string
  /** maker/taker/mixed */
  liquidityType: LiquidityType
  label: string
  /** whether this trade is a liquidation */
  liquidation?: Liquidation | undefined
  /** execution venue — always populated */
  tradeVenue: TradeVenue
  /** venue-native contract/security id — always populated */
  venueSymbol: string
  /** L1 snapshot at the fill instant (best-effort; empty on cache miss). */
  benchmark?: BenchmarkSnapshot | undefined
  /**
   * Parent order's type, copied when the fill is recorded so the trade is
   * self-describing without a client-side join. UNSPECIFIED when the parent
   * order's type wasn't known at record time (e.g. rows written before this
   * field existed).
   */
  orderType: OrderType
}

/**
 * Order information.
 *
 * `exchange`, `trade_venue`, and `venue_symbol` are all required and always
 * populated (see `Trade`).
 */
export interface Order {
  orderId: string
  accountId: string
  label: string
  symbol: string
  /** underlying market — always populated */
  exchange: Exchange
  side: OrderSide
  orderType: OrderType
  /** Decimal as string */
  quantity: string
  /** Price as string (decimal or special values like "market_price") */
  price?: string | undefined
  status: OrderStatus
  createdAt: string
  updatedAt: string
  /** the expiry of the instrument in ns, options etc */
  expiry?: string | undefined
  /** Decimal as string */
  filledQuantity?: string | undefined
  /** Decimal as string */
  avgFillPrice?: string | undefined
  /** the strike price of the instrument, options etc as decimal string */
  strike?: string | undefined
  instrumentKind: InstrumentKind
  /** whether this order is a liquidation */
  isLiquidation: boolean
  /** whether this order is for rebalance purposes */
  isRebalance: boolean
  /** GTC, IOC, FOK, etc. */
  timeInForce: string
  /** whether this order is reduce-only */
  reduceOnly: boolean
  /** execution venue — always populated */
  tradeVenue: TradeVenue
  /** venue-native order symbol/security id — always populated */
  venueSymbol: string
  /** L1 snapshot at the order-placement instant (best-effort; empty on cache miss). */
  arrivalBenchmark?: BenchmarkSnapshot | undefined
  /**
   * Human-readable reason this order was refused, set only alongside
   * status == ORDER_STATUS_REJECTED on a synthetic order a trade-venue
   * service synthesizes (not a real venue order id). Reuses the same
   * error text already shown via OrderExecutionError.error_message.
   */
  rejectReason?: string | undefined
  /**
   * Unit of `quantity` and `filled_quantity`, which always share one. QUOTE on
   * a spot market BUY sized in quote (Upbit `ord_type=price`, Bybit
   * `marketUnit=quoteCoin`) and on inverse futures/perps (USD contracts):
   * there `quantity` is the quote amount ordered and `filled_quantity` the
   * quote amount filled. UNSPECIFIED only on rows persisted before this field.
   */
  denomination: Denomination
}

/**
 * Position information.
 *
 * `exchange`, `trade_venue`, and `venue_symbol` are all required and always
 * populated. The legacy single-axis `exchange` lived at tag 4; the new market
 * field reuses the name but takes a fresh tag (23) so old wire data on tag 4
 * is dropped instead of being mis-parsed as the new field. Tag 4 is reserved
 * permanently; the name is reused intentionally.
 *
 * Derived `_usd` / `_base` fields and `pnl_denomination` are stamped
 * server-side in public-api — see `refresh_position_metrics`.
 */
export interface Position {
  accountId: string
  symbol: string
  /** long/short for derivatives */
  side?: OrderSide | undefined
  /** Decimal as string */
  quantity: string
  /** Decimal as string */
  avgPrice: string
  /** Decimal as string */
  markPrice?: string | undefined
  /** native unrealized PnL (base for inverse/options, quote for linear) */
  unrealizedPnl?: string | undefined
  /** native realized PnL (same denomination rules as unrealized_pnl) */
  realizedPnl?: string | undefined
  /** native daily PnL (same denomination rules) */
  dailyUnrealizedPnl?: string | undefined
  /** native initial margin (same denomination rules) */
  marginRequired?: string | undefined
  updatedAt: string
  /** the expiry of the instrument in ns, options etc as decimal string */
  expiry?: string | undefined
  /** the strike price of the instrument, options etc as decimal string */
  strike?: string | undefined
  /** delta in underlying-asset units (per spec: "Delta = Delta in underlying asset") */
  delta?: string | undefined
  /** native theta (USD/day for Deribit options) */
  theta?: string | undefined
  /** gamma in underlying-asset units */
  gamma?: string | undefined
  /** native vega (USD per 1% IV for Deribit options) */
  vega?: string | undefined
  /** Realized funding costs as decimal string */
  realizedFunding?: string | undefined
  /** rho per 1% rate move */
  rho?: string | undefined
  /** always populated */
  tradeVenue: TradeVenue
  /** underlying market — always populated */
  exchange: Exchange
  /** always populated */
  venueSymbol: string
  /** native maintenance margin (same denomination rules) */
  maintenanceMargin?: string | undefined
  /**
   * Spot/index price of the underlying used to derive the `_usd` / `_base`
   * fields below. Stamped at the same instant as the metrics. USD, decimal as string.
   */
  underlyingPrice?: string | undefined
  /** ---- Derived metrics — summable across a group ---- */
  deltaUsd?: string | undefined
  /** dollar gamma: USD-delta change per 1% spot move (gamma * S^2 / 100) */
  gammaUsd?: string | undefined
  /** native vega (already USD per 1% IV) */
  vegaUsd?: string | undefined
  /** native theta (already USD per day) */
  thetaUsd?: string | undefined
  /** PnL converted to USD */
  unrealizedPnlUsd?: string | undefined
  /** realized PnL converted to USD */
  realizedPnlUsd?: string | undefined
  /** daily PnL converted to USD */
  dailyUnrealizedPnlUsd?: string | undefined
  /** initial margin converted to USD */
  initialMarginUsd?: string | undefined
  /** maintenance margin converted to USD */
  maintenanceMarginUsd?: string | undefined
  /** ---- Derived metrics — denominated in base/underlying coin (per-row only) ---- */
  vegaBase?: string | undefined
  /** theta_usd / underlying_price */
  thetaBase?: string | undefined
  /** PnL in base coin */
  unrealizedPnlBase?: string | undefined
  /** realized PnL in base coin */
  realizedPnlBase?: string | undefined
  /** daily PnL in base coin */
  dailyUnrealizedPnlBase?: string | undefined
  /** initial margin in base coin */
  initialMarginBase?: string | undefined
  /** maintenance margin in base coin */
  maintenanceMarginBase?: string | undefined
  /**
   * Native denomination of `unrealized_pnl`, `realized_pnl`,
   * `daily_unrealized_pnl`, `margin_required`, `maintenance_margin`.
   * Stamped server-side so downstream consumers don't need a metadata
   * lookup. BASE = inverse perps + options; QUOTE = linear perps.
   */
  pnlDenomination: Denomination
  /**
   * Native denomination of `quantity`. After Deribit normalisation:
   * inverse perps → QUOTE (USD-fixed contract chunks); everything else
   * → BASE (linear perps via `size_currency`, options in base contracts
   * / notional). Always invariant under price moves.
   */
  sizeDenomination: Denomination
  /**
   * ---- Option implied-vol + return-on-capital (stamped in public-api positions_hub) ----
   * BREAKING SEMANTIC CHANGE (2026-08-18): this tag previously carried "implied
   * vol at avg_price re-solved at the current spot/expiry" — that quantity is now
   * `breakeven_iv` (tag 50). Consumers wanting the old number must repoint.
   * Qty-weighted mean implied vol across the fills that built this position, each
   * solved at that fill's own underlying price and time-to-expiry. Fraction
   * (1.0 = 100%). Fixed once established: a reduce leaves it unchanged, only an
   * add moves it, a side flip resets it. Options-only.
   *
   * Absent whenever the fill history cannot be trusted, which is a normal state,
   * not an error: the venue stamps no per-fill benchmark (only Deribit does
   * today), the position predates the server's lookback window, or the recovered
   * history is truncated far enough that it disagrees with the position's own
   * side. Render an absent value as blank — never as 0.
   */
  entryIv?: string | undefined
  /** implied vol at mark, fraction (1.0 = 100%); options-only */
  markIv?: string | undefined
  /** return on committed capital, percent (60.0 = +60%); all instruments */
  pnlPercent?: string | undefined
  /**
   * Venue-reported liquidation price, passed through as-is (decimal as string).
   * An approximation whenever margin is pooled across positions (cross/portfolio
   * margin) — it reflects the venue's own estimate, not a value we compute.
   */
  liquidationPrice?: string | undefined
  /**
   * Account's actual currently-selected leverage on this position, natively
   * venue-reported (not inferred from notional/margin). Decimal as string.
   * Absent for Deribit portfolio-margin accounts (no per-position leverage
   * concept there) and for symbols with no open position.
   */
  currentLeverage?: string | undefined
  /**
   * Implied vol that reprices `avg_price` at the CURRENT spot and time-to-expiry.
   * Moves with the market on every tick — this is NOT the vol traded at entry.
   * Holds the invariant sign(unrealized_pnl) == side * sign(mark_iv - breakeven_iv).
   * Fraction (1.0 = 100%); options-only.
   */
  breakevenIv?: string | undefined
  /**
   * Whether THIS position's margin is ring-fenced or drawn from the account's
   * shared pool. Venue-reported, never inferred: Hyperliquid's
   * `leverage.type`, Bybit's `tradeMode`. UNSPECIFIED on venues where the
   * choice is account-level rather than per-position (Deribit, Derive) — read
   * PortfolioData.margin_scope there.
   */
  marginScope: MarginScope
  /**
   * Call/put, stamped in public-api positions_hub from instrument metadata.
   * Options-only; absent for perps/futures/spot, and for an option whose
   * instrument is missing from the cache — fall back to parsing `symbol` then.
   */
  optionType?: OptionType | undefined
  /**
   * The venue's own sub-positions behind this netted row, for a venue that
   * holds several per instrument, each with its own margin and liquidation
   * price (Papertrade). Empty on every other venue: the row is the position.
   * Live only, never persisted. Always sent whole, never diffed: an empty
   * list on the wire means "no legs", not "unchanged".
   */
  legs: PositionLeg[]
}

/** One venue sub-position behind a netted `Position`. Decimals as strings. */
export interface PositionLeg {
  /** venue's sub-position id */
  id: string
  /** a leg can oppose the net side */
  side: OrderSide
  /** unsigned, in the row's size_denomination */
  quantity: string
  entryPrice: string
  marginUsd: string
  /** Price at which this leg alone is liquidated; absent when the venue gives none. */
  liquidationPrice?: string | undefined
  /** unix ms */
  openedAt: string
}

/** List wrappers for trading data */
export interface TradeList {
  trades: Trade[]
}

/**
 * Deposit/withdrawal ledger entry, venue-agnostic. Populated only from each
 * venue's dedicated transfer/deposit/withdrawal endpoint — never inferred
 * from raw balance deltas (a spot trade moves two balances at once and can
 * look like a transfer pair). `amount_usd` is the full venue-side equity
 * deduction/credit including any transfer fee, signed (positive = deposit,
 * negative = withdrawal) — this is what makes
 * equity(now) - equity(window_start) - net_transfers(window) exact.
 */
export interface Transfer {
  /** venue's own transfer id */
  id: string
  accountId: string
  tradeVenue: TradeVenue
  direction: TransferDirection
  currency: string
  /** signed, Decimal as string */
  amountUsd: string
  /** native currency amount, Decimal as string */
  rawAmount: string
  /** Decimal as string */
  fee?: string | undefined
  /** ms since epoch */
  executedAt: string
}

export interface TransferList {
  transfers: Transfer[]
}

export interface OrderList {
  orders: Order[]
}

export interface PositionList {
  positions: Position[]
  /**
   * True when `positions` is the venue's COMPLETE open-position set for the
   * account at the instant it was taken: any symbol the consumer holds and this
   * list omits is closed. Absent/false means an incremental update, where an
   * omitted symbol means "unchanged".
   *
   * Exists because absence otherwise clears nothing: a position closed inside a
   * venue message we failed to read is invisible to every incremental path, and
   * survives restarts (the consumer re-hydrates it from its own store). An empty
   * list with this set is meaningful — the account is flat — so consumers must
   * read the enclosing DataPayload.account_id rather than the first position.
   */
  isFullSnapshot: boolean
}

export interface InstrumentTradeList {
  instrumentTrades: InstrumentTrade[]
}

/** One rung of a venue-measured initial-margin leverage curve. */
export interface MarginCurvePoint {
  /** Position size in the curve's `size_unit`, decimal as string. */
  positionSize: string
  /**
   * Effective IM leverage the venue applies at that size:
   * `notional / initial_margin`, both as the venue reported them.
   */
  leverage: string
  /**
   * Maintenance-margin rate the venue applies at that size, as a fraction:
   * `maintenance_margin / notional` for a position of `position_size`
   * (0.005 = 0.5%). Decimal as string. Read on the same axis and per the same
   * `shape` as `leverage` (a TIERED rung's rate covers every size up to it).
   * Where a venue's maintenance margin carries a tier deduction (Bybit
   * `mmDeduction`) this is the effective rate at the rung's own size, so it is
   * exact there and conservative below it. Absent when the publisher cannot
   * state one (e.g. a Portfolio Margin probe) — consumers then have no
   * maintenance-margin tier for the curve and must not guess one.
   */
  maintenanceMarginRate?: string | undefined
}

/**
 * A venue's real initial-margin leverage as a function of position size,
 * measured by probing the venue rather than modelled locally.
 *
 * Exists because Deribit's August 2026 Standard Margin model made leverage
 * size-dependent — `L(N) = C2 + (C1-C2)*e^(-C4*N/(C3*NMax))` — while
 * `Instrument.max_leverage` still reports a single scalar that is only the
 * C1 end of that curve. The C1-C4 parameters are not exposed on any public
 * endpoint, so the curve is sampled from `private/get_margins` instead of
 * reconstructed from constants that would silently rot when the venue's risk
 * team retunes them.
 *
 * Keyed by margin model, not by account: the parameters are per-instrument,
 * but Portfolio Margin accounts do not use this model at all and must not
 * read an SM curve.
 */
export interface StoredMarginCurve {
  exchange: Exchange
  symbol: string
  /**
   * "SM" or "PM" — the margin model this curve describes, matching
   * PortfolioData.margin_model. An account on another model must not read it.
   */
  marginModel: string
  /**
   * Ascending by `position_size`. Consumers read them per `shape` and clamp
   * outside the end rungs.
   */
  points: MarginCurvePoint[]
  /**
   * The venue's hard position cap in the curve's `size_unit`, decimal as
   * string. Empty when the venue does not report one. NOTE: where this is
   * inferred from a probe refusal it is a LOWER BOUND on the real cap, so it
   * may only clamp a size HINT — never reject an order.
   */
  maxPositionSize: string
  generatedAt: string
  shape: MarginCurveShape
  sizeUnit: MarginCurveSizeUnit
}

function createBaseAssetRef(): AssetRef {
  return { asset: undefined, category: undefined }
}

export const AssetRef: MessageFns<AssetRef> = {
  encode(message: AssetRef, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.asset !== undefined) {
      writer.uint32(10).string(message.asset)
    }
    if (message.category !== undefined) {
      writer.uint32(16).int32(message.category)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssetRef {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAssetRef()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.asset = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.category = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AssetRef {
    return {
      asset: isSet(object.asset) ? globalThis.String(object.asset) : undefined,
      category: isSet(object.category) ? assetCategoryFromJSON(object.category) : undefined,
    }
  },

  toJSON(message: AssetRef): unknown {
    const obj: any = {}
    if (message.asset !== undefined) {
      obj.asset = message.asset
    }
    if (message.category !== undefined) {
      obj.category = assetCategoryToJSON(message.category)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AssetRef>, I>>(base?: I): AssetRef {
    return AssetRef.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AssetRef>, I>>(object: I): AssetRef {
    const message = createBaseAssetRef()
    message.asset = object.asset ?? undefined
    message.category = object.category ?? undefined
    return message
  },
}

function createBaseInstrumentTrade(): InstrumentTrade {
  return {
    symbol: '',
    tradeId: '',
    side: 0,
    price: 0,
    quantity: 0,
    quantityQuote: 0,
    underlying: '',
    iv: undefined,
    optionType: undefined,
    strikePrice: undefined,
    expiry: undefined,
    blockTradeId: undefined,
    liquidation: undefined,
    exchange: 0,
    timestampNs: '0',
    indexPrice: undefined,
  }
}

export const InstrumentTrade: MessageFns<InstrumentTrade> = {
  encode(message: InstrumentTrade, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.tradeId !== '') {
      writer.uint32(18).string(message.tradeId)
    }
    if (message.side !== 0) {
      writer.uint32(24).int32(message.side)
    }
    if (message.price !== 0) {
      writer.uint32(33).double(message.price)
    }
    if (message.quantity !== 0) {
      writer.uint32(41).double(message.quantity)
    }
    if (message.quantityQuote !== 0) {
      writer.uint32(49).double(message.quantityQuote)
    }
    if (message.underlying !== '') {
      writer.uint32(58).string(message.underlying)
    }
    if (message.iv !== undefined) {
      writer.uint32(65).double(message.iv)
    }
    if (message.optionType !== undefined) {
      writer.uint32(72).int32(message.optionType)
    }
    if (message.strikePrice !== undefined) {
      writer.uint32(82).string(message.strikePrice)
    }
    if (message.expiry !== undefined) {
      writer.uint32(88).int64(message.expiry)
    }
    if (message.blockTradeId !== undefined) {
      writer.uint32(98).string(message.blockTradeId)
    }
    if (message.liquidation !== undefined) {
      writer.uint32(104).int32(message.liquidation)
    }
    if (message.exchange !== 0) {
      writer.uint32(112).int32(message.exchange)
    }
    if (message.timestampNs !== '0') {
      writer.uint32(120).int64(message.timestampNs)
    }
    if (message.indexPrice !== undefined) {
      writer.uint32(129).double(message.indexPrice)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InstrumentTrade {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseInstrumentTrade()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.tradeId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 33) {
            break
          }

          message.price = reader.double()
          continue
        }
        case 5: {
          if (tag !== 41) {
            break
          }

          message.quantity = reader.double()
          continue
        }
        case 6: {
          if (tag !== 49) {
            break
          }

          message.quantityQuote = reader.double()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 8: {
          if (tag !== 65) {
            break
          }

          message.iv = reader.double()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.optionType = reader.int32() as any
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.strikePrice = reader.string()
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.expiry = reader.int64().toString()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.blockTradeId = reader.string()
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.liquidation = reader.int32() as any
          continue
        }
        case 14: {
          if (tag !== 112) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 15: {
          if (tag !== 120) {
            break
          }

          message.timestampNs = reader.int64().toString()
          continue
        }
        case 16: {
          if (tag !== 129) {
            break
          }

          message.indexPrice = reader.double()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): InstrumentTrade {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      tradeId: isSet(object.tradeId)
        ? globalThis.String(object.tradeId)
        : isSet(object.trade_id)
          ? globalThis.String(object.trade_id)
          : '',
      side: isSet(object.side) ? orderSideFromJSON(object.side) : 0,
      price: isSet(object.price) ? globalThis.Number(object.price) : 0,
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
      quantityQuote: isSet(object.quantityQuote)
        ? globalThis.Number(object.quantityQuote)
        : isSet(object.quantity_quote)
          ? globalThis.Number(object.quantity_quote)
          : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      iv: isSet(object.iv) ? globalThis.Number(object.iv) : undefined,
      optionType: isSet(object.optionType)
        ? optionTypeFromJSON(object.optionType)
        : isSet(object.option_type)
          ? optionTypeFromJSON(object.option_type)
          : undefined,
      strikePrice: isSet(object.strikePrice)
        ? globalThis.String(object.strikePrice)
        : isSet(object.strike_price)
          ? globalThis.String(object.strike_price)
          : undefined,
      expiry: isSet(object.expiry) ? globalThis.String(object.expiry) : undefined,
      blockTradeId: isSet(object.blockTradeId)
        ? globalThis.String(object.blockTradeId)
        : isSet(object.block_trade_id)
          ? globalThis.String(object.block_trade_id)
          : undefined,
      liquidation: isSet(object.liquidation) ? liquidationFromJSON(object.liquidation) : undefined,
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      timestampNs: isSet(object.timestampNs)
        ? globalThis.String(object.timestampNs)
        : isSet(object.timestamp_ns)
          ? globalThis.String(object.timestamp_ns)
          : '0',
      indexPrice: isSet(object.indexPrice)
        ? globalThis.Number(object.indexPrice)
        : isSet(object.index_price)
          ? globalThis.Number(object.index_price)
          : undefined,
    }
  },

  toJSON(message: InstrumentTrade): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.tradeId !== '') {
      obj.tradeId = message.tradeId
    }
    if (message.side !== 0) {
      obj.side = orderSideToJSON(message.side)
    }
    if (message.price !== 0) {
      obj.price = message.price
    }
    if (message.quantity !== 0) {
      obj.quantity = message.quantity
    }
    if (message.quantityQuote !== 0) {
      obj.quantityQuote = message.quantityQuote
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.iv !== undefined) {
      obj.iv = message.iv
    }
    if (message.optionType !== undefined) {
      obj.optionType = optionTypeToJSON(message.optionType)
    }
    if (message.strikePrice !== undefined) {
      obj.strikePrice = message.strikePrice
    }
    if (message.expiry !== undefined) {
      obj.expiry = message.expiry
    }
    if (message.blockTradeId !== undefined) {
      obj.blockTradeId = message.blockTradeId
    }
    if (message.liquidation !== undefined) {
      obj.liquidation = liquidationToJSON(message.liquidation)
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.timestampNs !== '0') {
      obj.timestampNs = message.timestampNs
    }
    if (message.indexPrice !== undefined) {
      obj.indexPrice = message.indexPrice
    }
    return obj
  },

  create<I extends Exact<DeepPartial<InstrumentTrade>, I>>(base?: I): InstrumentTrade {
    return InstrumentTrade.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<InstrumentTrade>, I>>(object: I): InstrumentTrade {
    const message = createBaseInstrumentTrade()
    message.symbol = object.symbol ?? ''
    message.tradeId = object.tradeId ?? ''
    message.side = object.side ?? 0
    message.price = object.price ?? 0
    message.quantity = object.quantity ?? 0
    message.quantityQuote = object.quantityQuote ?? 0
    message.underlying = object.underlying ?? ''
    message.iv = object.iv ?? undefined
    message.optionType = object.optionType ?? undefined
    message.strikePrice = object.strikePrice ?? undefined
    message.expiry = object.expiry ?? undefined
    message.blockTradeId = object.blockTradeId ?? undefined
    message.liquidation = object.liquidation ?? undefined
    message.exchange = object.exchange ?? 0
    message.timestampNs = object.timestampNs ?? '0'
    message.indexPrice = object.indexPrice ?? undefined
    return message
  },
}

function createBaseBenchmarkSnapshot(): BenchmarkSnapshot {
  return { bid: undefined, ask: undefined, mid: undefined, mark: undefined, underlying: undefined }
}

export const BenchmarkSnapshot: MessageFns<BenchmarkSnapshot> = {
  encode(message: BenchmarkSnapshot, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.bid !== undefined) {
      writer.uint32(10).string(message.bid)
    }
    if (message.ask !== undefined) {
      writer.uint32(18).string(message.ask)
    }
    if (message.mid !== undefined) {
      writer.uint32(26).string(message.mid)
    }
    if (message.mark !== undefined) {
      writer.uint32(34).string(message.mark)
    }
    if (message.underlying !== undefined) {
      writer.uint32(42).string(message.underlying)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BenchmarkSnapshot {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseBenchmarkSnapshot()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.bid = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.ask = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.mid = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.mark = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.underlying = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): BenchmarkSnapshot {
    return {
      bid: isSet(object.bid) ? globalThis.String(object.bid) : undefined,
      ask: isSet(object.ask) ? globalThis.String(object.ask) : undefined,
      mid: isSet(object.mid) ? globalThis.String(object.mid) : undefined,
      mark: isSet(object.mark) ? globalThis.String(object.mark) : undefined,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : undefined,
    }
  },

  toJSON(message: BenchmarkSnapshot): unknown {
    const obj: any = {}
    if (message.bid !== undefined) {
      obj.bid = message.bid
    }
    if (message.ask !== undefined) {
      obj.ask = message.ask
    }
    if (message.mid !== undefined) {
      obj.mid = message.mid
    }
    if (message.mark !== undefined) {
      obj.mark = message.mark
    }
    if (message.underlying !== undefined) {
      obj.underlying = message.underlying
    }
    return obj
  },

  create<I extends Exact<DeepPartial<BenchmarkSnapshot>, I>>(base?: I): BenchmarkSnapshot {
    return BenchmarkSnapshot.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<BenchmarkSnapshot>, I>>(object: I): BenchmarkSnapshot {
    const message = createBaseBenchmarkSnapshot()
    message.bid = object.bid ?? undefined
    message.ask = object.ask ?? undefined
    message.mid = object.mid ?? undefined
    message.mark = object.mark ?? undefined
    message.underlying = object.underlying ?? undefined
    return message
  },
}

function createBaseTrade(): Trade {
  return {
    id: '',
    orderId: '',
    accountId: '',
    symbol: '',
    exchange: 0,
    side: 0,
    quantity: '',
    price: '',
    fee: undefined,
    feeCurrency: undefined,
    executedAt: '0',
    liquidityType: 0,
    label: '',
    liquidation: undefined,
    tradeVenue: 0,
    venueSymbol: '',
    benchmark: undefined,
    orderType: 0,
  }
}

export const Trade: MessageFns<Trade> = {
  encode(message: Trade, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== '') {
      writer.uint32(10).string(message.id)
    }
    if (message.orderId !== '') {
      writer.uint32(18).string(message.orderId)
    }
    if (message.accountId !== '') {
      writer.uint32(26).string(message.accountId)
    }
    if (message.symbol !== '') {
      writer.uint32(34).string(message.symbol)
    }
    if (message.exchange !== 0) {
      writer.uint32(40).int32(message.exchange)
    }
    if (message.side !== 0) {
      writer.uint32(48).int32(message.side)
    }
    if (message.quantity !== '') {
      writer.uint32(58).string(message.quantity)
    }
    if (message.price !== '') {
      writer.uint32(66).string(message.price)
    }
    if (message.fee !== undefined) {
      writer.uint32(74).string(message.fee)
    }
    if (message.feeCurrency !== undefined) {
      writer.uint32(82).string(message.feeCurrency)
    }
    if (message.executedAt !== '0') {
      writer.uint32(88).int64(message.executedAt)
    }
    if (message.liquidityType !== 0) {
      writer.uint32(96).int32(message.liquidityType)
    }
    if (message.label !== '') {
      writer.uint32(106).string(message.label)
    }
    if (message.liquidation !== undefined) {
      writer.uint32(112).int32(message.liquidation)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(120).int32(message.tradeVenue)
    }
    if (message.venueSymbol !== '') {
      writer.uint32(130).string(message.venueSymbol)
    }
    if (message.benchmark !== undefined) {
      BenchmarkSnapshot.encode(message.benchmark, writer.uint32(138).fork()).join()
    }
    if (message.orderType !== 0) {
      writer.uint32(144).int32(message.orderType)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Trade {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTrade()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.id = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.orderId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.quantity = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.price = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.fee = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.feeCurrency = reader.string()
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.executedAt = reader.int64().toString()
          continue
        }
        case 12: {
          if (tag !== 96) {
            break
          }

          message.liquidityType = reader.int32() as any
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.label = reader.string()
          continue
        }
        case 14: {
          if (tag !== 112) {
            break
          }

          message.liquidation = reader.int32() as any
          continue
        }
        case 15: {
          if (tag !== 120) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.venueSymbol = reader.string()
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          message.benchmark = BenchmarkSnapshot.decode(reader, reader.uint32())
          continue
        }
        case 18: {
          if (tag !== 144) {
            break
          }

          message.orderType = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Trade {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : '',
      orderId: isSet(object.orderId)
        ? globalThis.String(object.orderId)
        : isSet(object.order_id)
          ? globalThis.String(object.order_id)
          : '',
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      side: isSet(object.side) ? orderSideFromJSON(object.side) : 0,
      quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
      price: isSet(object.price) ? globalThis.String(object.price) : '',
      fee: isSet(object.fee) ? globalThis.String(object.fee) : undefined,
      feeCurrency: isSet(object.feeCurrency)
        ? globalThis.String(object.feeCurrency)
        : isSet(object.fee_currency)
          ? globalThis.String(object.fee_currency)
          : undefined,
      executedAt: isSet(object.executedAt)
        ? globalThis.String(object.executedAt)
        : isSet(object.executed_at)
          ? globalThis.String(object.executed_at)
          : '0',
      liquidityType: isSet(object.liquidityType)
        ? liquidityTypeFromJSON(object.liquidityType)
        : isSet(object.liquidity_type)
          ? liquidityTypeFromJSON(object.liquidity_type)
          : 0,
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      liquidation: isSet(object.liquidation) ? liquidationFromJSON(object.liquidation) : undefined,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      venueSymbol: isSet(object.venueSymbol)
        ? globalThis.String(object.venueSymbol)
        : isSet(object.venue_symbol)
          ? globalThis.String(object.venue_symbol)
          : '',
      benchmark: isSet(object.benchmark) ? BenchmarkSnapshot.fromJSON(object.benchmark) : undefined,
      orderType: isSet(object.orderType)
        ? orderTypeFromJSON(object.orderType)
        : isSet(object.order_type)
          ? orderTypeFromJSON(object.order_type)
          : 0,
    }
  },

  toJSON(message: Trade): unknown {
    const obj: any = {}
    if (message.id !== '') {
      obj.id = message.id
    }
    if (message.orderId !== '') {
      obj.orderId = message.orderId
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.side !== 0) {
      obj.side = orderSideToJSON(message.side)
    }
    if (message.quantity !== '') {
      obj.quantity = message.quantity
    }
    if (message.price !== '') {
      obj.price = message.price
    }
    if (message.fee !== undefined) {
      obj.fee = message.fee
    }
    if (message.feeCurrency !== undefined) {
      obj.feeCurrency = message.feeCurrency
    }
    if (message.executedAt !== '0') {
      obj.executedAt = message.executedAt
    }
    if (message.liquidityType !== 0) {
      obj.liquidityType = liquidityTypeToJSON(message.liquidityType)
    }
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.liquidation !== undefined) {
      obj.liquidation = liquidationToJSON(message.liquidation)
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.venueSymbol !== '') {
      obj.venueSymbol = message.venueSymbol
    }
    if (message.benchmark !== undefined) {
      obj.benchmark = BenchmarkSnapshot.toJSON(message.benchmark)
    }
    if (message.orderType !== 0) {
      obj.orderType = orderTypeToJSON(message.orderType)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Trade>, I>>(base?: I): Trade {
    return Trade.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Trade>, I>>(object: I): Trade {
    const message = createBaseTrade()
    message.id = object.id ?? ''
    message.orderId = object.orderId ?? ''
    message.accountId = object.accountId ?? ''
    message.symbol = object.symbol ?? ''
    message.exchange = object.exchange ?? 0
    message.side = object.side ?? 0
    message.quantity = object.quantity ?? ''
    message.price = object.price ?? ''
    message.fee = object.fee ?? undefined
    message.feeCurrency = object.feeCurrency ?? undefined
    message.executedAt = object.executedAt ?? '0'
    message.liquidityType = object.liquidityType ?? 0
    message.label = object.label ?? ''
    message.liquidation = object.liquidation ?? undefined
    message.tradeVenue = object.tradeVenue ?? 0
    message.venueSymbol = object.venueSymbol ?? ''
    message.benchmark =
      object.benchmark !== undefined && object.benchmark !== null
        ? BenchmarkSnapshot.fromPartial(object.benchmark)
        : undefined
    message.orderType = object.orderType ?? 0
    return message
  },
}

function createBaseOrder(): Order {
  return {
    orderId: '',
    accountId: '',
    label: '',
    symbol: '',
    exchange: 0,
    side: 0,
    orderType: 0,
    quantity: '',
    price: undefined,
    status: 0,
    createdAt: '0',
    updatedAt: '0',
    expiry: undefined,
    filledQuantity: undefined,
    avgFillPrice: undefined,
    strike: undefined,
    instrumentKind: 0,
    isLiquidation: false,
    isRebalance: false,
    timeInForce: '',
    reduceOnly: false,
    tradeVenue: 0,
    venueSymbol: '',
    arrivalBenchmark: undefined,
    rejectReason: undefined,
    denomination: 0,
  }
}

export const Order: MessageFns<Order> = {
  encode(message: Order, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orderId !== '') {
      writer.uint32(10).string(message.orderId)
    }
    if (message.accountId !== '') {
      writer.uint32(18).string(message.accountId)
    }
    if (message.label !== '') {
      writer.uint32(26).string(message.label)
    }
    if (message.symbol !== '') {
      writer.uint32(34).string(message.symbol)
    }
    if (message.exchange !== 0) {
      writer.uint32(40).int32(message.exchange)
    }
    if (message.side !== 0) {
      writer.uint32(48).int32(message.side)
    }
    if (message.orderType !== 0) {
      writer.uint32(56).int32(message.orderType)
    }
    if (message.quantity !== '') {
      writer.uint32(66).string(message.quantity)
    }
    if (message.price !== undefined) {
      writer.uint32(74).string(message.price)
    }
    if (message.status !== 0) {
      writer.uint32(80).int32(message.status)
    }
    if (message.createdAt !== '0') {
      writer.uint32(88).int64(message.createdAt)
    }
    if (message.updatedAt !== '0') {
      writer.uint32(96).int64(message.updatedAt)
    }
    if (message.expiry !== undefined) {
      writer.uint32(104).int64(message.expiry)
    }
    if (message.filledQuantity !== undefined) {
      writer.uint32(114).string(message.filledQuantity)
    }
    if (message.avgFillPrice !== undefined) {
      writer.uint32(122).string(message.avgFillPrice)
    }
    if (message.strike !== undefined) {
      writer.uint32(130).string(message.strike)
    }
    if (message.instrumentKind !== 0) {
      writer.uint32(136).int32(message.instrumentKind)
    }
    if (message.isLiquidation !== false) {
      writer.uint32(144).bool(message.isLiquidation)
    }
    if (message.isRebalance !== false) {
      writer.uint32(152).bool(message.isRebalance)
    }
    if (message.timeInForce !== '') {
      writer.uint32(162).string(message.timeInForce)
    }
    if (message.reduceOnly !== false) {
      writer.uint32(168).bool(message.reduceOnly)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(176).int32(message.tradeVenue)
    }
    if (message.venueSymbol !== '') {
      writer.uint32(186).string(message.venueSymbol)
    }
    if (message.arrivalBenchmark !== undefined) {
      BenchmarkSnapshot.encode(message.arrivalBenchmark, writer.uint32(194).fork()).join()
    }
    if (message.rejectReason !== undefined) {
      writer.uint32(202).string(message.rejectReason)
    }
    if (message.denomination !== 0) {
      writer.uint32(208).int32(message.denomination)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Order {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOrder()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.orderId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.label = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.orderType = reader.int32() as any
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.quantity = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.price = reader.string()
          continue
        }
        case 10: {
          if (tag !== 80) {
            break
          }

          message.status = reader.int32() as any
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.createdAt = reader.int64().toString()
          continue
        }
        case 12: {
          if (tag !== 96) {
            break
          }

          message.updatedAt = reader.int64().toString()
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.expiry = reader.int64().toString()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.filledQuantity = reader.string()
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.avgFillPrice = reader.string()
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.strike = reader.string()
          continue
        }
        case 17: {
          if (tag !== 136) {
            break
          }

          message.instrumentKind = reader.int32() as any
          continue
        }
        case 18: {
          if (tag !== 144) {
            break
          }

          message.isLiquidation = reader.bool()
          continue
        }
        case 19: {
          if (tag !== 152) {
            break
          }

          message.isRebalance = reader.bool()
          continue
        }
        case 20: {
          if (tag !== 162) {
            break
          }

          message.timeInForce = reader.string()
          continue
        }
        case 21: {
          if (tag !== 168) {
            break
          }

          message.reduceOnly = reader.bool()
          continue
        }
        case 22: {
          if (tag !== 176) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 23: {
          if (tag !== 186) {
            break
          }

          message.venueSymbol = reader.string()
          continue
        }
        case 24: {
          if (tag !== 194) {
            break
          }

          message.arrivalBenchmark = BenchmarkSnapshot.decode(reader, reader.uint32())
          continue
        }
        case 25: {
          if (tag !== 202) {
            break
          }

          message.rejectReason = reader.string()
          continue
        }
        case 26: {
          if (tag !== 208) {
            break
          }

          message.denomination = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Order {
    return {
      orderId: isSet(object.orderId)
        ? globalThis.String(object.orderId)
        : isSet(object.order_id)
          ? globalThis.String(object.order_id)
          : '',
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      side: isSet(object.side) ? orderSideFromJSON(object.side) : 0,
      orderType: isSet(object.orderType)
        ? orderTypeFromJSON(object.orderType)
        : isSet(object.order_type)
          ? orderTypeFromJSON(object.order_type)
          : 0,
      quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
      price: isSet(object.price) ? globalThis.String(object.price) : undefined,
      status: isSet(object.status) ? orderStatusFromJSON(object.status) : 0,
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '0',
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
          ? globalThis.String(object.updated_at)
          : '0',
      expiry: isSet(object.expiry) ? globalThis.String(object.expiry) : undefined,
      filledQuantity: isSet(object.filledQuantity)
        ? globalThis.String(object.filledQuantity)
        : isSet(object.filled_quantity)
          ? globalThis.String(object.filled_quantity)
          : undefined,
      avgFillPrice: isSet(object.avgFillPrice)
        ? globalThis.String(object.avgFillPrice)
        : isSet(object.avg_fill_price)
          ? globalThis.String(object.avg_fill_price)
          : undefined,
      strike: isSet(object.strike) ? globalThis.String(object.strike) : undefined,
      instrumentKind: isSet(object.instrumentKind)
        ? instrumentKindFromJSON(object.instrumentKind)
        : isSet(object.instrument_kind)
          ? instrumentKindFromJSON(object.instrument_kind)
          : 0,
      isLiquidation: isSet(object.isLiquidation)
        ? globalThis.Boolean(object.isLiquidation)
        : isSet(object.is_liquidation)
          ? globalThis.Boolean(object.is_liquidation)
          : false,
      isRebalance: isSet(object.isRebalance)
        ? globalThis.Boolean(object.isRebalance)
        : isSet(object.is_rebalance)
          ? globalThis.Boolean(object.is_rebalance)
          : false,
      timeInForce: isSet(object.timeInForce)
        ? globalThis.String(object.timeInForce)
        : isSet(object.time_in_force)
          ? globalThis.String(object.time_in_force)
          : '',
      reduceOnly: isSet(object.reduceOnly)
        ? globalThis.Boolean(object.reduceOnly)
        : isSet(object.reduce_only)
          ? globalThis.Boolean(object.reduce_only)
          : false,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      venueSymbol: isSet(object.venueSymbol)
        ? globalThis.String(object.venueSymbol)
        : isSet(object.venue_symbol)
          ? globalThis.String(object.venue_symbol)
          : '',
      arrivalBenchmark: isSet(object.arrivalBenchmark)
        ? BenchmarkSnapshot.fromJSON(object.arrivalBenchmark)
        : isSet(object.arrival_benchmark)
          ? BenchmarkSnapshot.fromJSON(object.arrival_benchmark)
          : undefined,
      rejectReason: isSet(object.rejectReason)
        ? globalThis.String(object.rejectReason)
        : isSet(object.reject_reason)
          ? globalThis.String(object.reject_reason)
          : undefined,
      denomination: isSet(object.denomination) ? denominationFromJSON(object.denomination) : 0,
    }
  },

  toJSON(message: Order): unknown {
    const obj: any = {}
    if (message.orderId !== '') {
      obj.orderId = message.orderId
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.side !== 0) {
      obj.side = orderSideToJSON(message.side)
    }
    if (message.orderType !== 0) {
      obj.orderType = orderTypeToJSON(message.orderType)
    }
    if (message.quantity !== '') {
      obj.quantity = message.quantity
    }
    if (message.price !== undefined) {
      obj.price = message.price
    }
    if (message.status !== 0) {
      obj.status = orderStatusToJSON(message.status)
    }
    if (message.createdAt !== '0') {
      obj.createdAt = message.createdAt
    }
    if (message.updatedAt !== '0') {
      obj.updatedAt = message.updatedAt
    }
    if (message.expiry !== undefined) {
      obj.expiry = message.expiry
    }
    if (message.filledQuantity !== undefined) {
      obj.filledQuantity = message.filledQuantity
    }
    if (message.avgFillPrice !== undefined) {
      obj.avgFillPrice = message.avgFillPrice
    }
    if (message.strike !== undefined) {
      obj.strike = message.strike
    }
    if (message.instrumentKind !== 0) {
      obj.instrumentKind = instrumentKindToJSON(message.instrumentKind)
    }
    if (message.isLiquidation !== false) {
      obj.isLiquidation = message.isLiquidation
    }
    if (message.isRebalance !== false) {
      obj.isRebalance = message.isRebalance
    }
    if (message.timeInForce !== '') {
      obj.timeInForce = message.timeInForce
    }
    if (message.reduceOnly !== false) {
      obj.reduceOnly = message.reduceOnly
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.venueSymbol !== '') {
      obj.venueSymbol = message.venueSymbol
    }
    if (message.arrivalBenchmark !== undefined) {
      obj.arrivalBenchmark = BenchmarkSnapshot.toJSON(message.arrivalBenchmark)
    }
    if (message.rejectReason !== undefined) {
      obj.rejectReason = message.rejectReason
    }
    if (message.denomination !== 0) {
      obj.denomination = denominationToJSON(message.denomination)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Order>, I>>(base?: I): Order {
    return Order.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Order>, I>>(object: I): Order {
    const message = createBaseOrder()
    message.orderId = object.orderId ?? ''
    message.accountId = object.accountId ?? ''
    message.label = object.label ?? ''
    message.symbol = object.symbol ?? ''
    message.exchange = object.exchange ?? 0
    message.side = object.side ?? 0
    message.orderType = object.orderType ?? 0
    message.quantity = object.quantity ?? ''
    message.price = object.price ?? undefined
    message.status = object.status ?? 0
    message.createdAt = object.createdAt ?? '0'
    message.updatedAt = object.updatedAt ?? '0'
    message.expiry = object.expiry ?? undefined
    message.filledQuantity = object.filledQuantity ?? undefined
    message.avgFillPrice = object.avgFillPrice ?? undefined
    message.strike = object.strike ?? undefined
    message.instrumentKind = object.instrumentKind ?? 0
    message.isLiquidation = object.isLiquidation ?? false
    message.isRebalance = object.isRebalance ?? false
    message.timeInForce = object.timeInForce ?? ''
    message.reduceOnly = object.reduceOnly ?? false
    message.tradeVenue = object.tradeVenue ?? 0
    message.venueSymbol = object.venueSymbol ?? ''
    message.arrivalBenchmark =
      object.arrivalBenchmark !== undefined && object.arrivalBenchmark !== null
        ? BenchmarkSnapshot.fromPartial(object.arrivalBenchmark)
        : undefined
    message.rejectReason = object.rejectReason ?? undefined
    message.denomination = object.denomination ?? 0
    return message
  },
}

function createBasePosition(): Position {
  return {
    accountId: '',
    symbol: '',
    side: undefined,
    quantity: '',
    avgPrice: '',
    markPrice: undefined,
    unrealizedPnl: undefined,
    realizedPnl: undefined,
    dailyUnrealizedPnl: undefined,
    marginRequired: undefined,
    updatedAt: '0',
    expiry: undefined,
    strike: undefined,
    delta: undefined,
    theta: undefined,
    gamma: undefined,
    vega: undefined,
    realizedFunding: undefined,
    rho: undefined,
    tradeVenue: 0,
    exchange: 0,
    venueSymbol: '',
    maintenanceMargin: undefined,
    underlyingPrice: undefined,
    deltaUsd: undefined,
    gammaUsd: undefined,
    vegaUsd: undefined,
    thetaUsd: undefined,
    unrealizedPnlUsd: undefined,
    realizedPnlUsd: undefined,
    dailyUnrealizedPnlUsd: undefined,
    initialMarginUsd: undefined,
    maintenanceMarginUsd: undefined,
    vegaBase: undefined,
    thetaBase: undefined,
    unrealizedPnlBase: undefined,
    realizedPnlBase: undefined,
    dailyUnrealizedPnlBase: undefined,
    initialMarginBase: undefined,
    maintenanceMarginBase: undefined,
    pnlDenomination: 0,
    sizeDenomination: 0,
    entryIv: undefined,
    markIv: undefined,
    pnlPercent: undefined,
    liquidationPrice: undefined,
    currentLeverage: undefined,
    breakevenIv: undefined,
    marginScope: 0,
    optionType: undefined,
    legs: [],
  }
}

export const Position: MessageFns<Position> = {
  encode(message: Position, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(18).string(message.accountId)
    }
    if (message.symbol !== '') {
      writer.uint32(26).string(message.symbol)
    }
    if (message.side !== undefined) {
      writer.uint32(40).int32(message.side)
    }
    if (message.quantity !== '') {
      writer.uint32(50).string(message.quantity)
    }
    if (message.avgPrice !== '') {
      writer.uint32(58).string(message.avgPrice)
    }
    if (message.markPrice !== undefined) {
      writer.uint32(66).string(message.markPrice)
    }
    if (message.unrealizedPnl !== undefined) {
      writer.uint32(74).string(message.unrealizedPnl)
    }
    if (message.realizedPnl !== undefined) {
      writer.uint32(82).string(message.realizedPnl)
    }
    if (message.dailyUnrealizedPnl !== undefined) {
      writer.uint32(90).string(message.dailyUnrealizedPnl)
    }
    if (message.marginRequired !== undefined) {
      writer.uint32(98).string(message.marginRequired)
    }
    if (message.updatedAt !== '0') {
      writer.uint32(104).int64(message.updatedAt)
    }
    if (message.expiry !== undefined) {
      writer.uint32(112).int64(message.expiry)
    }
    if (message.strike !== undefined) {
      writer.uint32(122).string(message.strike)
    }
    if (message.delta !== undefined) {
      writer.uint32(130).string(message.delta)
    }
    if (message.theta !== undefined) {
      writer.uint32(138).string(message.theta)
    }
    if (message.gamma !== undefined) {
      writer.uint32(146).string(message.gamma)
    }
    if (message.vega !== undefined) {
      writer.uint32(154).string(message.vega)
    }
    if (message.realizedFunding !== undefined) {
      writer.uint32(162).string(message.realizedFunding)
    }
    if (message.rho !== undefined) {
      writer.uint32(170).string(message.rho)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(176).int32(message.tradeVenue)
    }
    if (message.exchange !== 0) {
      writer.uint32(184).int32(message.exchange)
    }
    if (message.venueSymbol !== '') {
      writer.uint32(194).string(message.venueSymbol)
    }
    if (message.maintenanceMargin !== undefined) {
      writer.uint32(202).string(message.maintenanceMargin)
    }
    if (message.underlyingPrice !== undefined) {
      writer.uint32(210).string(message.underlyingPrice)
    }
    if (message.deltaUsd !== undefined) {
      writer.uint32(218).string(message.deltaUsd)
    }
    if (message.gammaUsd !== undefined) {
      writer.uint32(226).string(message.gammaUsd)
    }
    if (message.vegaUsd !== undefined) {
      writer.uint32(234).string(message.vegaUsd)
    }
    if (message.thetaUsd !== undefined) {
      writer.uint32(242).string(message.thetaUsd)
    }
    if (message.unrealizedPnlUsd !== undefined) {
      writer.uint32(250).string(message.unrealizedPnlUsd)
    }
    if (message.realizedPnlUsd !== undefined) {
      writer.uint32(258).string(message.realizedPnlUsd)
    }
    if (message.dailyUnrealizedPnlUsd !== undefined) {
      writer.uint32(266).string(message.dailyUnrealizedPnlUsd)
    }
    if (message.initialMarginUsd !== undefined) {
      writer.uint32(274).string(message.initialMarginUsd)
    }
    if (message.maintenanceMarginUsd !== undefined) {
      writer.uint32(282).string(message.maintenanceMarginUsd)
    }
    if (message.vegaBase !== undefined) {
      writer.uint32(290).string(message.vegaBase)
    }
    if (message.thetaBase !== undefined) {
      writer.uint32(298).string(message.thetaBase)
    }
    if (message.unrealizedPnlBase !== undefined) {
      writer.uint32(306).string(message.unrealizedPnlBase)
    }
    if (message.realizedPnlBase !== undefined) {
      writer.uint32(314).string(message.realizedPnlBase)
    }
    if (message.dailyUnrealizedPnlBase !== undefined) {
      writer.uint32(322).string(message.dailyUnrealizedPnlBase)
    }
    if (message.initialMarginBase !== undefined) {
      writer.uint32(330).string(message.initialMarginBase)
    }
    if (message.maintenanceMarginBase !== undefined) {
      writer.uint32(338).string(message.maintenanceMarginBase)
    }
    if (message.pnlDenomination !== 0) {
      writer.uint32(344).int32(message.pnlDenomination)
    }
    if (message.sizeDenomination !== 0) {
      writer.uint32(352).int32(message.sizeDenomination)
    }
    if (message.entryIv !== undefined) {
      writer.uint32(362).string(message.entryIv)
    }
    if (message.markIv !== undefined) {
      writer.uint32(370).string(message.markIv)
    }
    if (message.pnlPercent !== undefined) {
      writer.uint32(378).string(message.pnlPercent)
    }
    if (message.liquidationPrice !== undefined) {
      writer.uint32(386).string(message.liquidationPrice)
    }
    if (message.currentLeverage !== undefined) {
      writer.uint32(394).string(message.currentLeverage)
    }
    if (message.breakevenIv !== undefined) {
      writer.uint32(402).string(message.breakevenIv)
    }
    if (message.marginScope !== 0) {
      writer.uint32(408).int32(message.marginScope)
    }
    if (message.optionType !== undefined) {
      writer.uint32(416).int32(message.optionType)
    }
    for (const v of message.legs) {
      PositionLeg.encode(v!, writer.uint32(426).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Position {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePosition()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.quantity = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.avgPrice = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.markPrice = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.unrealizedPnl = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.realizedPnl = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.dailyUnrealizedPnl = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.marginRequired = reader.string()
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.updatedAt = reader.int64().toString()
          continue
        }
        case 14: {
          if (tag !== 112) {
            break
          }

          message.expiry = reader.int64().toString()
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.strike = reader.string()
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.delta = reader.string()
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          message.theta = reader.string()
          continue
        }
        case 18: {
          if (tag !== 146) {
            break
          }

          message.gamma = reader.string()
          continue
        }
        case 19: {
          if (tag !== 154) {
            break
          }

          message.vega = reader.string()
          continue
        }
        case 20: {
          if (tag !== 162) {
            break
          }

          message.realizedFunding = reader.string()
          continue
        }
        case 21: {
          if (tag !== 170) {
            break
          }

          message.rho = reader.string()
          continue
        }
        case 22: {
          if (tag !== 176) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 23: {
          if (tag !== 184) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 24: {
          if (tag !== 194) {
            break
          }

          message.venueSymbol = reader.string()
          continue
        }
        case 25: {
          if (tag !== 202) {
            break
          }

          message.maintenanceMargin = reader.string()
          continue
        }
        case 26: {
          if (tag !== 210) {
            break
          }

          message.underlyingPrice = reader.string()
          continue
        }
        case 27: {
          if (tag !== 218) {
            break
          }

          message.deltaUsd = reader.string()
          continue
        }
        case 28: {
          if (tag !== 226) {
            break
          }

          message.gammaUsd = reader.string()
          continue
        }
        case 29: {
          if (tag !== 234) {
            break
          }

          message.vegaUsd = reader.string()
          continue
        }
        case 30: {
          if (tag !== 242) {
            break
          }

          message.thetaUsd = reader.string()
          continue
        }
        case 31: {
          if (tag !== 250) {
            break
          }

          message.unrealizedPnlUsd = reader.string()
          continue
        }
        case 32: {
          if (tag !== 258) {
            break
          }

          message.realizedPnlUsd = reader.string()
          continue
        }
        case 33: {
          if (tag !== 266) {
            break
          }

          message.dailyUnrealizedPnlUsd = reader.string()
          continue
        }
        case 34: {
          if (tag !== 274) {
            break
          }

          message.initialMarginUsd = reader.string()
          continue
        }
        case 35: {
          if (tag !== 282) {
            break
          }

          message.maintenanceMarginUsd = reader.string()
          continue
        }
        case 36: {
          if (tag !== 290) {
            break
          }

          message.vegaBase = reader.string()
          continue
        }
        case 37: {
          if (tag !== 298) {
            break
          }

          message.thetaBase = reader.string()
          continue
        }
        case 38: {
          if (tag !== 306) {
            break
          }

          message.unrealizedPnlBase = reader.string()
          continue
        }
        case 39: {
          if (tag !== 314) {
            break
          }

          message.realizedPnlBase = reader.string()
          continue
        }
        case 40: {
          if (tag !== 322) {
            break
          }

          message.dailyUnrealizedPnlBase = reader.string()
          continue
        }
        case 41: {
          if (tag !== 330) {
            break
          }

          message.initialMarginBase = reader.string()
          continue
        }
        case 42: {
          if (tag !== 338) {
            break
          }

          message.maintenanceMarginBase = reader.string()
          continue
        }
        case 43: {
          if (tag !== 344) {
            break
          }

          message.pnlDenomination = reader.int32() as any
          continue
        }
        case 44: {
          if (tag !== 352) {
            break
          }

          message.sizeDenomination = reader.int32() as any
          continue
        }
        case 45: {
          if (tag !== 362) {
            break
          }

          message.entryIv = reader.string()
          continue
        }
        case 46: {
          if (tag !== 370) {
            break
          }

          message.markIv = reader.string()
          continue
        }
        case 47: {
          if (tag !== 378) {
            break
          }

          message.pnlPercent = reader.string()
          continue
        }
        case 48: {
          if (tag !== 386) {
            break
          }

          message.liquidationPrice = reader.string()
          continue
        }
        case 49: {
          if (tag !== 394) {
            break
          }

          message.currentLeverage = reader.string()
          continue
        }
        case 50: {
          if (tag !== 402) {
            break
          }

          message.breakevenIv = reader.string()
          continue
        }
        case 51: {
          if (tag !== 408) {
            break
          }

          message.marginScope = reader.int32() as any
          continue
        }
        case 52: {
          if (tag !== 416) {
            break
          }

          message.optionType = reader.int32() as any
          continue
        }
        case 53: {
          if (tag !== 426) {
            break
          }

          message.legs.push(PositionLeg.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Position {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      side: isSet(object.side) ? orderSideFromJSON(object.side) : undefined,
      quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
      avgPrice: isSet(object.avgPrice)
        ? globalThis.String(object.avgPrice)
        : isSet(object.avg_price)
          ? globalThis.String(object.avg_price)
          : '',
      markPrice: isSet(object.markPrice)
        ? globalThis.String(object.markPrice)
        : isSet(object.mark_price)
          ? globalThis.String(object.mark_price)
          : undefined,
      unrealizedPnl: isSet(object.unrealizedPnl)
        ? globalThis.String(object.unrealizedPnl)
        : isSet(object.unrealized_pnl)
          ? globalThis.String(object.unrealized_pnl)
          : undefined,
      realizedPnl: isSet(object.realizedPnl)
        ? globalThis.String(object.realizedPnl)
        : isSet(object.realized_pnl)
          ? globalThis.String(object.realized_pnl)
          : undefined,
      dailyUnrealizedPnl: isSet(object.dailyUnrealizedPnl)
        ? globalThis.String(object.dailyUnrealizedPnl)
        : isSet(object.daily_unrealized_pnl)
          ? globalThis.String(object.daily_unrealized_pnl)
          : undefined,
      marginRequired: isSet(object.marginRequired)
        ? globalThis.String(object.marginRequired)
        : isSet(object.margin_required)
          ? globalThis.String(object.margin_required)
          : undefined,
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
          ? globalThis.String(object.updated_at)
          : '0',
      expiry: isSet(object.expiry) ? globalThis.String(object.expiry) : undefined,
      strike: isSet(object.strike) ? globalThis.String(object.strike) : undefined,
      delta: isSet(object.delta) ? globalThis.String(object.delta) : undefined,
      theta: isSet(object.theta) ? globalThis.String(object.theta) : undefined,
      gamma: isSet(object.gamma) ? globalThis.String(object.gamma) : undefined,
      vega: isSet(object.vega) ? globalThis.String(object.vega) : undefined,
      realizedFunding: isSet(object.realizedFunding)
        ? globalThis.String(object.realizedFunding)
        : isSet(object.realized_funding)
          ? globalThis.String(object.realized_funding)
          : undefined,
      rho: isSet(object.rho) ? globalThis.String(object.rho) : undefined,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      venueSymbol: isSet(object.venueSymbol)
        ? globalThis.String(object.venueSymbol)
        : isSet(object.venue_symbol)
          ? globalThis.String(object.venue_symbol)
          : '',
      maintenanceMargin: isSet(object.maintenanceMargin)
        ? globalThis.String(object.maintenanceMargin)
        : isSet(object.maintenance_margin)
          ? globalThis.String(object.maintenance_margin)
          : undefined,
      underlyingPrice: isSet(object.underlyingPrice)
        ? globalThis.String(object.underlyingPrice)
        : isSet(object.underlying_price)
          ? globalThis.String(object.underlying_price)
          : undefined,
      deltaUsd: isSet(object.deltaUsd)
        ? globalThis.String(object.deltaUsd)
        : isSet(object.delta_usd)
          ? globalThis.String(object.delta_usd)
          : undefined,
      gammaUsd: isSet(object.gammaUsd)
        ? globalThis.String(object.gammaUsd)
        : isSet(object.gamma_usd)
          ? globalThis.String(object.gamma_usd)
          : undefined,
      vegaUsd: isSet(object.vegaUsd)
        ? globalThis.String(object.vegaUsd)
        : isSet(object.vega_usd)
          ? globalThis.String(object.vega_usd)
          : undefined,
      thetaUsd: isSet(object.thetaUsd)
        ? globalThis.String(object.thetaUsd)
        : isSet(object.theta_usd)
          ? globalThis.String(object.theta_usd)
          : undefined,
      unrealizedPnlUsd: isSet(object.unrealizedPnlUsd)
        ? globalThis.String(object.unrealizedPnlUsd)
        : isSet(object.unrealized_pnl_usd)
          ? globalThis.String(object.unrealized_pnl_usd)
          : undefined,
      realizedPnlUsd: isSet(object.realizedPnlUsd)
        ? globalThis.String(object.realizedPnlUsd)
        : isSet(object.realized_pnl_usd)
          ? globalThis.String(object.realized_pnl_usd)
          : undefined,
      dailyUnrealizedPnlUsd: isSet(object.dailyUnrealizedPnlUsd)
        ? globalThis.String(object.dailyUnrealizedPnlUsd)
        : isSet(object.daily_unrealized_pnl_usd)
          ? globalThis.String(object.daily_unrealized_pnl_usd)
          : undefined,
      initialMarginUsd: isSet(object.initialMarginUsd)
        ? globalThis.String(object.initialMarginUsd)
        : isSet(object.initial_margin_usd)
          ? globalThis.String(object.initial_margin_usd)
          : undefined,
      maintenanceMarginUsd: isSet(object.maintenanceMarginUsd)
        ? globalThis.String(object.maintenanceMarginUsd)
        : isSet(object.maintenance_margin_usd)
          ? globalThis.String(object.maintenance_margin_usd)
          : undefined,
      vegaBase: isSet(object.vegaBase)
        ? globalThis.String(object.vegaBase)
        : isSet(object.vega_base)
          ? globalThis.String(object.vega_base)
          : undefined,
      thetaBase: isSet(object.thetaBase)
        ? globalThis.String(object.thetaBase)
        : isSet(object.theta_base)
          ? globalThis.String(object.theta_base)
          : undefined,
      unrealizedPnlBase: isSet(object.unrealizedPnlBase)
        ? globalThis.String(object.unrealizedPnlBase)
        : isSet(object.unrealized_pnl_base)
          ? globalThis.String(object.unrealized_pnl_base)
          : undefined,
      realizedPnlBase: isSet(object.realizedPnlBase)
        ? globalThis.String(object.realizedPnlBase)
        : isSet(object.realized_pnl_base)
          ? globalThis.String(object.realized_pnl_base)
          : undefined,
      dailyUnrealizedPnlBase: isSet(object.dailyUnrealizedPnlBase)
        ? globalThis.String(object.dailyUnrealizedPnlBase)
        : isSet(object.daily_unrealized_pnl_base)
          ? globalThis.String(object.daily_unrealized_pnl_base)
          : undefined,
      initialMarginBase: isSet(object.initialMarginBase)
        ? globalThis.String(object.initialMarginBase)
        : isSet(object.initial_margin_base)
          ? globalThis.String(object.initial_margin_base)
          : undefined,
      maintenanceMarginBase: isSet(object.maintenanceMarginBase)
        ? globalThis.String(object.maintenanceMarginBase)
        : isSet(object.maintenance_margin_base)
          ? globalThis.String(object.maintenance_margin_base)
          : undefined,
      pnlDenomination: isSet(object.pnlDenomination)
        ? denominationFromJSON(object.pnlDenomination)
        : isSet(object.pnl_denomination)
          ? denominationFromJSON(object.pnl_denomination)
          : 0,
      sizeDenomination: isSet(object.sizeDenomination)
        ? denominationFromJSON(object.sizeDenomination)
        : isSet(object.size_denomination)
          ? denominationFromJSON(object.size_denomination)
          : 0,
      entryIv: isSet(object.entryIv)
        ? globalThis.String(object.entryIv)
        : isSet(object.entry_iv)
          ? globalThis.String(object.entry_iv)
          : undefined,
      markIv: isSet(object.markIv)
        ? globalThis.String(object.markIv)
        : isSet(object.mark_iv)
          ? globalThis.String(object.mark_iv)
          : undefined,
      pnlPercent: isSet(object.pnlPercent)
        ? globalThis.String(object.pnlPercent)
        : isSet(object.pnl_percent)
          ? globalThis.String(object.pnl_percent)
          : undefined,
      liquidationPrice: isSet(object.liquidationPrice)
        ? globalThis.String(object.liquidationPrice)
        : isSet(object.liquidation_price)
          ? globalThis.String(object.liquidation_price)
          : undefined,
      currentLeverage: isSet(object.currentLeverage)
        ? globalThis.String(object.currentLeverage)
        : isSet(object.current_leverage)
          ? globalThis.String(object.current_leverage)
          : undefined,
      breakevenIv: isSet(object.breakevenIv)
        ? globalThis.String(object.breakevenIv)
        : isSet(object.breakeven_iv)
          ? globalThis.String(object.breakeven_iv)
          : undefined,
      marginScope: isSet(object.marginScope)
        ? marginScopeFromJSON(object.marginScope)
        : isSet(object.margin_scope)
          ? marginScopeFromJSON(object.margin_scope)
          : 0,
      optionType: isSet(object.optionType)
        ? optionTypeFromJSON(object.optionType)
        : isSet(object.option_type)
          ? optionTypeFromJSON(object.option_type)
          : undefined,
      legs: globalThis.Array.isArray(object?.legs)
        ? object.legs.map((e: any) => PositionLeg.fromJSON(e))
        : [],
    }
  },

  toJSON(message: Position): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.side !== undefined) {
      obj.side = orderSideToJSON(message.side)
    }
    if (message.quantity !== '') {
      obj.quantity = message.quantity
    }
    if (message.avgPrice !== '') {
      obj.avgPrice = message.avgPrice
    }
    if (message.markPrice !== undefined) {
      obj.markPrice = message.markPrice
    }
    if (message.unrealizedPnl !== undefined) {
      obj.unrealizedPnl = message.unrealizedPnl
    }
    if (message.realizedPnl !== undefined) {
      obj.realizedPnl = message.realizedPnl
    }
    if (message.dailyUnrealizedPnl !== undefined) {
      obj.dailyUnrealizedPnl = message.dailyUnrealizedPnl
    }
    if (message.marginRequired !== undefined) {
      obj.marginRequired = message.marginRequired
    }
    if (message.updatedAt !== '0') {
      obj.updatedAt = message.updatedAt
    }
    if (message.expiry !== undefined) {
      obj.expiry = message.expiry
    }
    if (message.strike !== undefined) {
      obj.strike = message.strike
    }
    if (message.delta !== undefined) {
      obj.delta = message.delta
    }
    if (message.theta !== undefined) {
      obj.theta = message.theta
    }
    if (message.gamma !== undefined) {
      obj.gamma = message.gamma
    }
    if (message.vega !== undefined) {
      obj.vega = message.vega
    }
    if (message.realizedFunding !== undefined) {
      obj.realizedFunding = message.realizedFunding
    }
    if (message.rho !== undefined) {
      obj.rho = message.rho
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.venueSymbol !== '') {
      obj.venueSymbol = message.venueSymbol
    }
    if (message.maintenanceMargin !== undefined) {
      obj.maintenanceMargin = message.maintenanceMargin
    }
    if (message.underlyingPrice !== undefined) {
      obj.underlyingPrice = message.underlyingPrice
    }
    if (message.deltaUsd !== undefined) {
      obj.deltaUsd = message.deltaUsd
    }
    if (message.gammaUsd !== undefined) {
      obj.gammaUsd = message.gammaUsd
    }
    if (message.vegaUsd !== undefined) {
      obj.vegaUsd = message.vegaUsd
    }
    if (message.thetaUsd !== undefined) {
      obj.thetaUsd = message.thetaUsd
    }
    if (message.unrealizedPnlUsd !== undefined) {
      obj.unrealizedPnlUsd = message.unrealizedPnlUsd
    }
    if (message.realizedPnlUsd !== undefined) {
      obj.realizedPnlUsd = message.realizedPnlUsd
    }
    if (message.dailyUnrealizedPnlUsd !== undefined) {
      obj.dailyUnrealizedPnlUsd = message.dailyUnrealizedPnlUsd
    }
    if (message.initialMarginUsd !== undefined) {
      obj.initialMarginUsd = message.initialMarginUsd
    }
    if (message.maintenanceMarginUsd !== undefined) {
      obj.maintenanceMarginUsd = message.maintenanceMarginUsd
    }
    if (message.vegaBase !== undefined) {
      obj.vegaBase = message.vegaBase
    }
    if (message.thetaBase !== undefined) {
      obj.thetaBase = message.thetaBase
    }
    if (message.unrealizedPnlBase !== undefined) {
      obj.unrealizedPnlBase = message.unrealizedPnlBase
    }
    if (message.realizedPnlBase !== undefined) {
      obj.realizedPnlBase = message.realizedPnlBase
    }
    if (message.dailyUnrealizedPnlBase !== undefined) {
      obj.dailyUnrealizedPnlBase = message.dailyUnrealizedPnlBase
    }
    if (message.initialMarginBase !== undefined) {
      obj.initialMarginBase = message.initialMarginBase
    }
    if (message.maintenanceMarginBase !== undefined) {
      obj.maintenanceMarginBase = message.maintenanceMarginBase
    }
    if (message.pnlDenomination !== 0) {
      obj.pnlDenomination = denominationToJSON(message.pnlDenomination)
    }
    if (message.sizeDenomination !== 0) {
      obj.sizeDenomination = denominationToJSON(message.sizeDenomination)
    }
    if (message.entryIv !== undefined) {
      obj.entryIv = message.entryIv
    }
    if (message.markIv !== undefined) {
      obj.markIv = message.markIv
    }
    if (message.pnlPercent !== undefined) {
      obj.pnlPercent = message.pnlPercent
    }
    if (message.liquidationPrice !== undefined) {
      obj.liquidationPrice = message.liquidationPrice
    }
    if (message.currentLeverage !== undefined) {
      obj.currentLeverage = message.currentLeverage
    }
    if (message.breakevenIv !== undefined) {
      obj.breakevenIv = message.breakevenIv
    }
    if (message.marginScope !== 0) {
      obj.marginScope = marginScopeToJSON(message.marginScope)
    }
    if (message.optionType !== undefined) {
      obj.optionType = optionTypeToJSON(message.optionType)
    }
    if (message.legs?.length) {
      obj.legs = message.legs.map((e) => PositionLeg.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Position>, I>>(base?: I): Position {
    return Position.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Position>, I>>(object: I): Position {
    const message = createBasePosition()
    message.accountId = object.accountId ?? ''
    message.symbol = object.symbol ?? ''
    message.side = object.side ?? undefined
    message.quantity = object.quantity ?? ''
    message.avgPrice = object.avgPrice ?? ''
    message.markPrice = object.markPrice ?? undefined
    message.unrealizedPnl = object.unrealizedPnl ?? undefined
    message.realizedPnl = object.realizedPnl ?? undefined
    message.dailyUnrealizedPnl = object.dailyUnrealizedPnl ?? undefined
    message.marginRequired = object.marginRequired ?? undefined
    message.updatedAt = object.updatedAt ?? '0'
    message.expiry = object.expiry ?? undefined
    message.strike = object.strike ?? undefined
    message.delta = object.delta ?? undefined
    message.theta = object.theta ?? undefined
    message.gamma = object.gamma ?? undefined
    message.vega = object.vega ?? undefined
    message.realizedFunding = object.realizedFunding ?? undefined
    message.rho = object.rho ?? undefined
    message.tradeVenue = object.tradeVenue ?? 0
    message.exchange = object.exchange ?? 0
    message.venueSymbol = object.venueSymbol ?? ''
    message.maintenanceMargin = object.maintenanceMargin ?? undefined
    message.underlyingPrice = object.underlyingPrice ?? undefined
    message.deltaUsd = object.deltaUsd ?? undefined
    message.gammaUsd = object.gammaUsd ?? undefined
    message.vegaUsd = object.vegaUsd ?? undefined
    message.thetaUsd = object.thetaUsd ?? undefined
    message.unrealizedPnlUsd = object.unrealizedPnlUsd ?? undefined
    message.realizedPnlUsd = object.realizedPnlUsd ?? undefined
    message.dailyUnrealizedPnlUsd = object.dailyUnrealizedPnlUsd ?? undefined
    message.initialMarginUsd = object.initialMarginUsd ?? undefined
    message.maintenanceMarginUsd = object.maintenanceMarginUsd ?? undefined
    message.vegaBase = object.vegaBase ?? undefined
    message.thetaBase = object.thetaBase ?? undefined
    message.unrealizedPnlBase = object.unrealizedPnlBase ?? undefined
    message.realizedPnlBase = object.realizedPnlBase ?? undefined
    message.dailyUnrealizedPnlBase = object.dailyUnrealizedPnlBase ?? undefined
    message.initialMarginBase = object.initialMarginBase ?? undefined
    message.maintenanceMarginBase = object.maintenanceMarginBase ?? undefined
    message.pnlDenomination = object.pnlDenomination ?? 0
    message.sizeDenomination = object.sizeDenomination ?? 0
    message.entryIv = object.entryIv ?? undefined
    message.markIv = object.markIv ?? undefined
    message.pnlPercent = object.pnlPercent ?? undefined
    message.liquidationPrice = object.liquidationPrice ?? undefined
    message.currentLeverage = object.currentLeverage ?? undefined
    message.breakevenIv = object.breakevenIv ?? undefined
    message.marginScope = object.marginScope ?? 0
    message.optionType = object.optionType ?? undefined
    message.legs = object.legs?.map((e) => PositionLeg.fromPartial(e)) || []
    return message
  },
}

function createBasePositionLeg(): PositionLeg {
  return {
    id: '',
    side: 0,
    quantity: '',
    entryPrice: '',
    marginUsd: '',
    liquidationPrice: undefined,
    openedAt: '0',
  }
}

export const PositionLeg: MessageFns<PositionLeg> = {
  encode(message: PositionLeg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== '') {
      writer.uint32(10).string(message.id)
    }
    if (message.side !== 0) {
      writer.uint32(16).int32(message.side)
    }
    if (message.quantity !== '') {
      writer.uint32(26).string(message.quantity)
    }
    if (message.entryPrice !== '') {
      writer.uint32(34).string(message.entryPrice)
    }
    if (message.marginUsd !== '') {
      writer.uint32(42).string(message.marginUsd)
    }
    if (message.liquidationPrice !== undefined) {
      writer.uint32(50).string(message.liquidationPrice)
    }
    if (message.openedAt !== '0') {
      writer.uint32(56).int64(message.openedAt)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PositionLeg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePositionLeg()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.id = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.quantity = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.entryPrice = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.marginUsd = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.liquidationPrice = reader.string()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.openedAt = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PositionLeg {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : '',
      side: isSet(object.side) ? orderSideFromJSON(object.side) : 0,
      quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
      entryPrice: isSet(object.entryPrice)
        ? globalThis.String(object.entryPrice)
        : isSet(object.entry_price)
          ? globalThis.String(object.entry_price)
          : '',
      marginUsd: isSet(object.marginUsd)
        ? globalThis.String(object.marginUsd)
        : isSet(object.margin_usd)
          ? globalThis.String(object.margin_usd)
          : '',
      liquidationPrice: isSet(object.liquidationPrice)
        ? globalThis.String(object.liquidationPrice)
        : isSet(object.liquidation_price)
          ? globalThis.String(object.liquidation_price)
          : undefined,
      openedAt: isSet(object.openedAt)
        ? globalThis.String(object.openedAt)
        : isSet(object.opened_at)
          ? globalThis.String(object.opened_at)
          : '0',
    }
  },

  toJSON(message: PositionLeg): unknown {
    const obj: any = {}
    if (message.id !== '') {
      obj.id = message.id
    }
    if (message.side !== 0) {
      obj.side = orderSideToJSON(message.side)
    }
    if (message.quantity !== '') {
      obj.quantity = message.quantity
    }
    if (message.entryPrice !== '') {
      obj.entryPrice = message.entryPrice
    }
    if (message.marginUsd !== '') {
      obj.marginUsd = message.marginUsd
    }
    if (message.liquidationPrice !== undefined) {
      obj.liquidationPrice = message.liquidationPrice
    }
    if (message.openedAt !== '0') {
      obj.openedAt = message.openedAt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PositionLeg>, I>>(base?: I): PositionLeg {
    return PositionLeg.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PositionLeg>, I>>(object: I): PositionLeg {
    const message = createBasePositionLeg()
    message.id = object.id ?? ''
    message.side = object.side ?? 0
    message.quantity = object.quantity ?? ''
    message.entryPrice = object.entryPrice ?? ''
    message.marginUsd = object.marginUsd ?? ''
    message.liquidationPrice = object.liquidationPrice ?? undefined
    message.openedAt = object.openedAt ?? '0'
    return message
  },
}

function createBaseTradeList(): TradeList {
  return { trades: [] }
}

export const TradeList: MessageFns<TradeList> = {
  encode(message: TradeList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.trades) {
      Trade.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TradeList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTradeList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.trades.push(Trade.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TradeList {
    return {
      trades: globalThis.Array.isArray(object?.trades)
        ? object.trades.map((e: any) => Trade.fromJSON(e))
        : [],
    }
  },

  toJSON(message: TradeList): unknown {
    const obj: any = {}
    if (message.trades?.length) {
      obj.trades = message.trades.map((e) => Trade.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TradeList>, I>>(base?: I): TradeList {
    return TradeList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TradeList>, I>>(object: I): TradeList {
    const message = createBaseTradeList()
    message.trades = object.trades?.map((e) => Trade.fromPartial(e)) || []
    return message
  },
}

function createBaseTransfer(): Transfer {
  return {
    id: '',
    accountId: '',
    tradeVenue: 0,
    direction: 0,
    currency: '',
    amountUsd: '',
    rawAmount: '',
    fee: undefined,
    executedAt: '0',
  }
}

export const Transfer: MessageFns<Transfer> = {
  encode(message: Transfer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== '') {
      writer.uint32(10).string(message.id)
    }
    if (message.accountId !== '') {
      writer.uint32(18).string(message.accountId)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(24).int32(message.tradeVenue)
    }
    if (message.direction !== 0) {
      writer.uint32(32).int32(message.direction)
    }
    if (message.currency !== '') {
      writer.uint32(42).string(message.currency)
    }
    if (message.amountUsd !== '') {
      writer.uint32(50).string(message.amountUsd)
    }
    if (message.rawAmount !== '') {
      writer.uint32(58).string(message.rawAmount)
    }
    if (message.fee !== undefined) {
      writer.uint32(66).string(message.fee)
    }
    if (message.executedAt !== '0') {
      writer.uint32(72).int64(message.executedAt)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Transfer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTransfer()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.id = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.direction = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.amountUsd = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.rawAmount = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.fee = reader.string()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.executedAt = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Transfer {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : '',
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      direction: isSet(object.direction) ? transferDirectionFromJSON(object.direction) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      amountUsd: isSet(object.amountUsd)
        ? globalThis.String(object.amountUsd)
        : isSet(object.amount_usd)
          ? globalThis.String(object.amount_usd)
          : '',
      rawAmount: isSet(object.rawAmount)
        ? globalThis.String(object.rawAmount)
        : isSet(object.raw_amount)
          ? globalThis.String(object.raw_amount)
          : '',
      fee: isSet(object.fee) ? globalThis.String(object.fee) : undefined,
      executedAt: isSet(object.executedAt)
        ? globalThis.String(object.executedAt)
        : isSet(object.executed_at)
          ? globalThis.String(object.executed_at)
          : '0',
    }
  },

  toJSON(message: Transfer): unknown {
    const obj: any = {}
    if (message.id !== '') {
      obj.id = message.id
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.direction !== 0) {
      obj.direction = transferDirectionToJSON(message.direction)
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.amountUsd !== '') {
      obj.amountUsd = message.amountUsd
    }
    if (message.rawAmount !== '') {
      obj.rawAmount = message.rawAmount
    }
    if (message.fee !== undefined) {
      obj.fee = message.fee
    }
    if (message.executedAt !== '0') {
      obj.executedAt = message.executedAt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Transfer>, I>>(base?: I): Transfer {
    return Transfer.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Transfer>, I>>(object: I): Transfer {
    const message = createBaseTransfer()
    message.id = object.id ?? ''
    message.accountId = object.accountId ?? ''
    message.tradeVenue = object.tradeVenue ?? 0
    message.direction = object.direction ?? 0
    message.currency = object.currency ?? ''
    message.amountUsd = object.amountUsd ?? ''
    message.rawAmount = object.rawAmount ?? ''
    message.fee = object.fee ?? undefined
    message.executedAt = object.executedAt ?? '0'
    return message
  },
}

function createBaseTransferList(): TransferList {
  return { transfers: [] }
}

export const TransferList: MessageFns<TransferList> = {
  encode(message: TransferList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.transfers) {
      Transfer.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TransferList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTransferList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.transfers.push(Transfer.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TransferList {
    return {
      transfers: globalThis.Array.isArray(object?.transfers)
        ? object.transfers.map((e: any) => Transfer.fromJSON(e))
        : [],
    }
  },

  toJSON(message: TransferList): unknown {
    const obj: any = {}
    if (message.transfers?.length) {
      obj.transfers = message.transfers.map((e) => Transfer.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TransferList>, I>>(base?: I): TransferList {
    return TransferList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TransferList>, I>>(object: I): TransferList {
    const message = createBaseTransferList()
    message.transfers = object.transfers?.map((e) => Transfer.fromPartial(e)) || []
    return message
  },
}

function createBaseOrderList(): OrderList {
  return { orders: [] }
}

export const OrderList: MessageFns<OrderList> = {
  encode(message: OrderList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.orders) {
      Order.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrderList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOrderList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.orders.push(Order.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OrderList {
    return {
      orders: globalThis.Array.isArray(object?.orders)
        ? object.orders.map((e: any) => Order.fromJSON(e))
        : [],
    }
  },

  toJSON(message: OrderList): unknown {
    const obj: any = {}
    if (message.orders?.length) {
      obj.orders = message.orders.map((e) => Order.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OrderList>, I>>(base?: I): OrderList {
    return OrderList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OrderList>, I>>(object: I): OrderList {
    const message = createBaseOrderList()
    message.orders = object.orders?.map((e) => Order.fromPartial(e)) || []
    return message
  },
}

function createBasePositionList(): PositionList {
  return { positions: [], isFullSnapshot: false }
}

export const PositionList: MessageFns<PositionList> = {
  encode(message: PositionList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.positions) {
      Position.encode(v!, writer.uint32(10).fork()).join()
    }
    if (message.isFullSnapshot !== false) {
      writer.uint32(16).bool(message.isFullSnapshot)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PositionList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePositionList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.positions.push(Position.decode(reader, reader.uint32()))
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.isFullSnapshot = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PositionList {
    return {
      positions: globalThis.Array.isArray(object?.positions)
        ? object.positions.map((e: any) => Position.fromJSON(e))
        : [],
      isFullSnapshot: isSet(object.isFullSnapshot)
        ? globalThis.Boolean(object.isFullSnapshot)
        : isSet(object.is_full_snapshot)
          ? globalThis.Boolean(object.is_full_snapshot)
          : false,
    }
  },

  toJSON(message: PositionList): unknown {
    const obj: any = {}
    if (message.positions?.length) {
      obj.positions = message.positions.map((e) => Position.toJSON(e))
    }
    if (message.isFullSnapshot !== false) {
      obj.isFullSnapshot = message.isFullSnapshot
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PositionList>, I>>(base?: I): PositionList {
    return PositionList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PositionList>, I>>(object: I): PositionList {
    const message = createBasePositionList()
    message.positions = object.positions?.map((e) => Position.fromPartial(e)) || []
    message.isFullSnapshot = object.isFullSnapshot ?? false
    return message
  },
}

function createBaseInstrumentTradeList(): InstrumentTradeList {
  return { instrumentTrades: [] }
}

export const InstrumentTradeList: MessageFns<InstrumentTradeList> = {
  encode(message: InstrumentTradeList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.instrumentTrades) {
      InstrumentTrade.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InstrumentTradeList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseInstrumentTradeList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.instrumentTrades.push(InstrumentTrade.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): InstrumentTradeList {
    return {
      instrumentTrades: globalThis.Array.isArray(object?.instrumentTrades)
        ? object.instrumentTrades.map((e: any) => InstrumentTrade.fromJSON(e))
        : globalThis.Array.isArray(object?.instrument_trades)
          ? object.instrument_trades.map((e: any) => InstrumentTrade.fromJSON(e))
          : [],
    }
  },

  toJSON(message: InstrumentTradeList): unknown {
    const obj: any = {}
    if (message.instrumentTrades?.length) {
      obj.instrumentTrades = message.instrumentTrades.map((e) => InstrumentTrade.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<InstrumentTradeList>, I>>(base?: I): InstrumentTradeList {
    return InstrumentTradeList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<InstrumentTradeList>, I>>(
    object: I
  ): InstrumentTradeList {
    const message = createBaseInstrumentTradeList()
    message.instrumentTrades =
      object.instrumentTrades?.map((e) => InstrumentTrade.fromPartial(e)) || []
    return message
  },
}

function createBaseMarginCurvePoint(): MarginCurvePoint {
  return { positionSize: '', leverage: '', maintenanceMarginRate: undefined }
}

export const MarginCurvePoint: MessageFns<MarginCurvePoint> = {
  encode(message: MarginCurvePoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.positionSize !== '') {
      writer.uint32(10).string(message.positionSize)
    }
    if (message.leverage !== '') {
      writer.uint32(18).string(message.leverage)
    }
    if (message.maintenanceMarginRate !== undefined) {
      writer.uint32(26).string(message.maintenanceMarginRate)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MarginCurvePoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMarginCurvePoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.positionSize = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.leverage = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.maintenanceMarginRate = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MarginCurvePoint {
    return {
      positionSize: isSet(object.positionSize)
        ? globalThis.String(object.positionSize)
        : isSet(object.position_size)
          ? globalThis.String(object.position_size)
          : '',
      leverage: isSet(object.leverage) ? globalThis.String(object.leverage) : '',
      maintenanceMarginRate: isSet(object.maintenanceMarginRate)
        ? globalThis.String(object.maintenanceMarginRate)
        : isSet(object.maintenance_margin_rate)
          ? globalThis.String(object.maintenance_margin_rate)
          : undefined,
    }
  },

  toJSON(message: MarginCurvePoint): unknown {
    const obj: any = {}
    if (message.positionSize !== '') {
      obj.positionSize = message.positionSize
    }
    if (message.leverage !== '') {
      obj.leverage = message.leverage
    }
    if (message.maintenanceMarginRate !== undefined) {
      obj.maintenanceMarginRate = message.maintenanceMarginRate
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MarginCurvePoint>, I>>(base?: I): MarginCurvePoint {
    return MarginCurvePoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MarginCurvePoint>, I>>(object: I): MarginCurvePoint {
    const message = createBaseMarginCurvePoint()
    message.positionSize = object.positionSize ?? ''
    message.leverage = object.leverage ?? ''
    message.maintenanceMarginRate = object.maintenanceMarginRate ?? undefined
    return message
  },
}

function createBaseStoredMarginCurve(): StoredMarginCurve {
  return {
    exchange: 0,
    symbol: '',
    marginModel: '',
    points: [],
    maxPositionSize: '',
    generatedAt: '0',
    shape: 0,
    sizeUnit: 0,
  }
}

export const StoredMarginCurve: MessageFns<StoredMarginCurve> = {
  encode(message: StoredMarginCurve, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    if (message.marginModel !== '') {
      writer.uint32(26).string(message.marginModel)
    }
    for (const v of message.points) {
      MarginCurvePoint.encode(v!, writer.uint32(34).fork()).join()
    }
    if (message.maxPositionSize !== '') {
      writer.uint32(42).string(message.maxPositionSize)
    }
    if (message.generatedAt !== '0') {
      writer.uint32(48).int64(message.generatedAt)
    }
    if (message.shape !== 0) {
      writer.uint32(56).int32(message.shape)
    }
    if (message.sizeUnit !== 0) {
      writer.uint32(64).int32(message.sizeUnit)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StoredMarginCurve {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseStoredMarginCurve()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.marginModel = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.points.push(MarginCurvePoint.decode(reader, reader.uint32()))
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.maxPositionSize = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.generatedAt = reader.int64().toString()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.shape = reader.int32() as any
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.sizeUnit = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): StoredMarginCurve {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      marginModel: isSet(object.marginModel)
        ? globalThis.String(object.marginModel)
        : isSet(object.margin_model)
          ? globalThis.String(object.margin_model)
          : '',
      points: globalThis.Array.isArray(object?.points)
        ? object.points.map((e: any) => MarginCurvePoint.fromJSON(e))
        : [],
      maxPositionSize: isSet(object.maxPositionSize)
        ? globalThis.String(object.maxPositionSize)
        : isSet(object.max_position_size)
          ? globalThis.String(object.max_position_size)
          : '',
      generatedAt: isSet(object.generatedAt)
        ? globalThis.String(object.generatedAt)
        : isSet(object.generated_at)
          ? globalThis.String(object.generated_at)
          : '0',
      shape: isSet(object.shape) ? marginCurveShapeFromJSON(object.shape) : 0,
      sizeUnit: isSet(object.sizeUnit)
        ? marginCurveSizeUnitFromJSON(object.sizeUnit)
        : isSet(object.size_unit)
          ? marginCurveSizeUnitFromJSON(object.size_unit)
          : 0,
    }
  },

  toJSON(message: StoredMarginCurve): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.marginModel !== '') {
      obj.marginModel = message.marginModel
    }
    if (message.points?.length) {
      obj.points = message.points.map((e) => MarginCurvePoint.toJSON(e))
    }
    if (message.maxPositionSize !== '') {
      obj.maxPositionSize = message.maxPositionSize
    }
    if (message.generatedAt !== '0') {
      obj.generatedAt = message.generatedAt
    }
    if (message.shape !== 0) {
      obj.shape = marginCurveShapeToJSON(message.shape)
    }
    if (message.sizeUnit !== 0) {
      obj.sizeUnit = marginCurveSizeUnitToJSON(message.sizeUnit)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<StoredMarginCurve>, I>>(base?: I): StoredMarginCurve {
    return StoredMarginCurve.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<StoredMarginCurve>, I>>(object: I): StoredMarginCurve {
    const message = createBaseStoredMarginCurve()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.marginModel = object.marginModel ?? ''
    message.points = object.points?.map((e) => MarginCurvePoint.fromPartial(e)) || []
    message.maxPositionSize = object.maxPositionSize ?? ''
    message.generatedAt = object.generatedAt ?? '0'
    message.shape = object.shape ?? 0
    message.sizeUnit = object.sizeUnit ?? 0
    return message
  },
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends globalThis.Array<infer U>
    ? globalThis.Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
      ? ReadonlyArray<DeepPartial<U>>
      : T extends {}
        ? { [K in keyof T]?: DeepPartial<T[K]> }
        : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never }

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter
  decode(input: BinaryReader | Uint8Array, length?: number): T
  fromJSON(object: any): T
  toJSON(message: T): unknown
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T
}
